<template>
  <div id="divContainer" v-on:click="exitmenu" class="page-effect">
    <!-- <TopMenu /> -->
    <section
      @click="onClickHandler"
      id="sectionId"
      class="d-flex my-profile image-fix pb-8"
      style="min-height: calc(100vh - 225px)"
    >
      <div
        v-if="showProfileLoader"
        class="common-loader"
        style="
          margin: 0px;
          padding: 0px;
          position: fixed;
          right: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
          z-index: 30001;
          opacity: 1;
          transform: scale(2);
        "
      >
        <div class="loader">
          <v-progress-circular
            size="50"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </div>

      <div class="container-fluid">
        <v-row class="d-flex justify-content-center align-items-center">
          <v-col cols="10" md="10" sm="10" class="px-0">
            <v-row no-gutters :justify="isFromMainLobby ? '' : 'center'">
              <v-col
                cols="12"
                :sm="isFromMainLobby ? 6 : 12"
                :md="isFromMainLobby ? 6 : 12"
              >
                <h1
                  id="headerText"
                  :style="
                    $vuetify.breakpoint.xsOnly ? 'text-align: center;' : ''
                  "
                  class="page-head text-uppercase mb-0 pb-2"
                  :class="isFromMainLobby ? 'mt-4' : 'centerText'"
                >
                  {{ $t("myprofile.myProfile") }}
                </h1>
              </v-col>
              <v-spacer v-if="isFromMainLobby"></v-spacer>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="col p-0 m-0"
                style="flex-direction: row-reverse; display: flex"
              >
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!---contentarea---->
        <div
          v-for="attendee in attendeeData"
          v-bind:key="attendee.id"
          :style="isFromMainLobby ? '' : 'justify-content: center;'"
          class="row attendee-details-popup attendee-list mt-0 ht-100"
          id="attendeeProfile"
        >
          <div class="row">
            <div class="col-lg-10 col-md-12 offset-lg-1 offset-md-0">
              <div class="row">
                <div :class="isFromMainLobby ? 'col-lg-3 prof' : ''">
                  <div
                    class="profile-hld-box p-3 text-center"
                    style="height: 100%"
                    id="profileSocial"
                    :style="
                      isFromMainLobby
                        ? 'box-shadow: rgb(0 0 0 / 10%) 0px 0.0625rem 0.125rem, rgb(0 0 0 / 15%) 0px 0.25rem 1rem -0.125rem;'
                        : 'box-shadow: none !important'
                    "
                  >
                    <div class="top-img-box full-width pb-3 pt-0">
                      <input
                        id="fuProfile"
                        type="file"
                        @change="onFileChange"
                        ref="file"
                        style="display: none"
                      />

                      <div
                        class="grey-bg-texthld profile-details-white-hld m-0 mb-3"
                      >
                        <span
                          v-show="isFromMainLobby"
                          class="attendee-img-area"
                          v-if="attendee.Image != ''"
                        >
                          <img
                            v-bind:src="attendee.Image"
                            v-bind:alt="attendee.Name"
                            style="
                              height: auto !important;
                              max-width: 100% !important;
                            "
                            @error="attendee.Image = ''"
                          />
                          <label
                            v-if="isFromMainLobby"
                            v-on:click="openUpload"
                            class="profile-edit edit_ico"
                            data-tag="profileImageChange"
                            tabindex="6 "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16px"
                              height="22"
                              viewBox="0 0 13 12"
                            >
                              <path
                                id="camera.svg"
                                class="cls-1"
                                d="M1916.75,364.488a2.245,2.245,0,1,0-2.25,2.225A1.978,1.978,0,0,0,1916.75,364.488Zm-5.4-5.187h-2.04a1.271,1.271,0,0,0-.93.391,1.33,1.33,0,0,0-.38.953v8a1.328,1.328,0,0,0,.38.953,1.267,1.267,0,0,0,.93.391h10.38a1.235,1.235,0,0,0,.93-0.391,1.288,1.288,0,0,0,.38-0.953v-8a1.29,1.29,0,0,0-.38-0.953,1.239,1.239,0,0,0-.93-0.391h-2.07l-1.18-1.312h-3.9Zm-0.34,5.187a3.386,3.386,0,0,1,1.02-2.469,3.3,3.3,0,0,1,2.46-1.031,3.5,3.5,0,0,1,0,7,3.3,3.3,0,0,1-2.46-1.03A3.386,3.386,0,0,1,1911.01,364.488Z"
                                transform="translate(-1908 -358)"
                              />
                            </svg>
                          </label>
                        </span>

                        <span class="attendee-img-area" v-else>
                          <span
                            style="font-size: 40px; text-transform: uppercase"
                            >{{ getInitials() }}</span
                          >
                          <label
                            v-on:click="openUpload"
                            v-if="isFromMainLobby"
                            class="profile-edit edit_ico"
                            data-tag="profileImageChange"
                          >
                            <svg
                              version="1.1"
                              id="Capa_1"
                              width="18px"
                              height="18px"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              x="0px"
                              y="0px"
                              viewBox="0 0 477.873 477.873"
                              xml:space="preserve"
                            >
                              <g>
                                <g>
                                  <path
                                    d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                  />
                                </g>
                              </g>
                              <g>
                                <g>
                                  <path
                                    d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955C443.754,73.631,440.467,81.575,434.603,87.419z"
                                  />
                                </g>
                              </g>
                            </svg>
                          </label>
                        </span>
                        <div class="full-name">
                          <h3 data-text="Name" id="AttName">
                            {{ attendee.Salutation
                            }}{{ attendee.FirstName + " " + attendee.LastName }}
                          </h3>
                        </div>
                        <!-- <div class="ld-board-points">
                    <p><span>300</span>&nbsp;Points</p>
                  </div> -->
                        <div class="attendee-first-last-name">
                          <h3 data-text="First Name" id="AttName_first">
                            {{ attendee.FirstName }}
                          </h3>
                          <h3 data-text="Last Name" id="AttName_last">
                            {{ attendee.LastName }}
                          </h3>

                          <input
                            class="profile-edit-box"
                            title="First Name"
                            type="text"
                            v-model="attendee.FirstName"
                            placeholder="First Name"
                            @change="Liveupdate('First Name has been Updated')"
                          />
                          <input
                            class="profile-edit-box"
                            title="Last Name"
                            type="text"
                            v-model="attendee.LastName"
                            placeholder="Last Name"
                            @change="Liveupdate('Last Name has been Updated')"
                          />
                        </div>
                        <div class="title-line">
                          <input
                            class="profile-edit-box"
                            title="Title"
                            type="text"
                            v-model="attendee.Title"
                            placeholder="Title"
                            @change="Liveupdate('Title has been Updated')"
                          />
                          <input
                            class="profile-edit-box"
                            title="Company"
                            type="text"
                            v-model="attendee.Company"
                            placeholder="Company"
                            @change="Liveupdate('Company has been Updated')"
                          />
                          <h4 data-text="Title" id="Atttitle" class="mx-2">
                            {{ attendee.Title }}
                          </h4>
                          <!-- <span class="comma">,</span> -->
                          <p data-text="Company" id="Attcompany" class="mx-2">
                            {{ attendee.Company }}
                          </p>

                          <p data-text="Email" id="AttEmail" class="mx-2">
                            {{ attendee.Email }}
                          </p>
                          <p
                            v-show="attendee.Phone != ''"
                            data-text="Phone"
                            id="AttPhone"
                            class="mx-2"
                          >
                            {{ attendee.Phone }}
                          </p>
                          <p
                            v-show="
                              attendee.RegistrationType != '' &&
                              attendee.RegistrationType.RegistrationType !=
                                '' &&
                              isFromMainLobby
                            "
                            data-text="RegistrationType"
                            id="AttRegistrationType"
                            class="mx-2"
                          >
                            RegistrationType:
                            {{ attendee.RegistrationType.RegistrationType }}
                          </p>

                          <div class="user-address">
                            <p
                              v-show="attendee.MailingAddress != ''"
                              data-text="MailingAddress"
                              id="AttMailingAddress"
                              class="mx-2"
                            >
                              {{ attendee.MailingAddress }},
                            </p>
                            <!-- <span class="comma">,</span> -->

                            <!-- <span class="comma">,</span> -->
                            <p
                              v-show="attendee.City != ''"
                              data-text="City"
                              id="AttCity"
                              class="mx-2"
                            >
                              {{ attendee.City }},
                            </p>
                            <p
                              v-show="attendee.State != ''"
                              data-text="State"
                              id="AttState"
                              class="mx-2"
                            >
                              {{ attendee.State }},
                            </p>
                            <!-- <span class="comma">,</span> -->
                            <p
                              v-show="attendee.Country != ''"
                              data-text="Country"
                              id="AttCountry"
                              class="mx-2"
                            >
                              {{ attendee.Country }}
                            </p>
                            <p
                              v-show="attendee.Zip != ''"
                              data-text="Zip"
                              id="AttZip"
                              class="mx-2"
                            >
                              {{ attendee.Zip }}
                            </p>
                          </div>
                        </div>

                        <div class="socialLinkProf">
                          <ul>
                            <li>
                              <a
                                id="anchFB"
                                v-bind:href="attendee.Facebook"
                                target="_blank"
                                data-tag="profileFacebook"
                              >
                                <p class="mx-2">
                                  <svg
                                    enable-background="new 0 0 512 512"
                                    height="20px"
                                    id="Layer_1"
                                    version="1.1"
                                    viewBox="0 0 512 512"
                                    width="20px"
                                    xml:space="preserve"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                  >
                                    <g>
                                      <path
                                        d="M191.844,511.5V288.375h-68.313V188h69.875v-83.063c0,0,3.188-104.625,92.813-105.438h99.75V98h-61.875   c0,0-26.125,0-26.125,29.438c0,29.375,0,62.313,0,62.313h89.5l-10.75,100.313h-77.188V511.5H191.844z"
                                      />
                                    </g>
                                  </svg>
                                </p>
                              </a>
                              <span data-text="Facebook" id="Attfacebook">{{
                                attendee.Facebook
                              }}</span>
                              <input
                                class="profile-edit-box"
                                title="Facebook"
                                type="text"
                                v-model="attendee.Facebook"
                                placeholder="Facebook"
                                @change="
                                  Liveupdate('Facebook has been Updated')
                                "
                              />
                            </li>
                            <li>
                              <a
                                id="anchTwit"
                                v-bind:href="attendee.Twitter"
                                target="_blank"
                                data-tag="profileTwitter"
                              >
                                <p class="mx-2">
                                  <svg
                                    id="Layer_1"
                                    height="48px"
                                    width="30px"
                                    style="
                                      enable-background: new 0 0 512 512;
                                      margin-bottom: 6px;
                                    "
                                    version="1.1"
                                    viewBox="0 0 512 512"
                                    xml:space="preserve"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                  >
                                    <path
                                      class="st0"
                                      d="M196.9,462c120.3,0,186.1-99.7,186.1-186.1c0-2.8,0-5.6-0.2-8.5c12.8-9.3,23.8-20.7,32.6-33.9  c-11.9,5.3-24.6,8.8-37.6,10.3c13.7-8.2,23.9-21,28.8-36.2c-12.8,7.6-26.9,13-41.5,15.9c-24.8-26.3-66.2-27.6-92.5-2.8  c-17,16-24.2,39.8-18.9,62.5c-52.6-2.6-101.6-27.5-134.8-68.3c-17.4,29.9-8.5,68.1,20.2,87.3c-10.4-0.3-20.6-3.1-29.7-8.2  c0,0.3,0,0.5,0,0.8c0,31.1,22,57.9,52.5,64.1c-9.6,2.6-19.7,3-29.5,1.1c8.6,26.6,33.1,44.9,61.1,45.4  c-23.2,18.2-51.8,28.1-81.2,28.1c-5.2,0-10.4-0.3-15.6-0.9C126.5,451.8,161.3,462,196.9,462"
                                      id="XMLID_22_"
                                    />
                                  </svg>
                                </p>
                              </a>
                              <span data-text="Twitter" id="Atttwitter">{{
                                attendee.Twitter
                              }}</span>
                              <input
                                class="profile-edit-box"
                                title="Twitter"
                                type="text"
                                v-model="attendee.Twitter"
                                placeholder="Twitter"
                                @change="Liveupdate('Twitter has been Updated')"
                              />
                            </li>
                            <!--<li>
                          <a v-bind:href="attendee.GooglePlus" target="_blank">
                            <p class="mx-2">
                              <img
                                src="data:image/svg+xml;base64,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"
                              />
                            </p>
                          </a>
                          <span data-text="GooglePlus" id="Attgoogleplus">{{attendee.GooglePlus}}</span>
                      </li>-->
                            <li>
                              <a
                                id="anchLinkedIn"
                                v-bind:href="attendee.LinkedIn"
                                target="_blank"
                                data-tag="profileLinkedin"
                              >
                                <p class="mx-2">
                                  <svg
                                    baseProfile="tiny"
                                    height="26px"
                                    id="Layer_1"
                                    version="1.2"
                                    viewBox="0 0 24 24"
                                    width="32px"
                                    xml:space="preserve"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                  >
                                    <g>
                                      <path
                                        d="M8,19H5V9h3V19z M19,19h-3v-5.342c0-1.392-0.496-2.085-1.479-2.085c-0.779,0-1.273,0.388-1.521,1.165C13,14,13,19,13,19h-3   c0,0,0.04-9,0-10h2.368l0.183,2h0.062c0.615-1,1.598-1.678,2.946-1.678c1.025,0,1.854,0.285,2.487,1.001   C18.683,11.04,19,12.002,19,13.353V19z"
                                      />
                                    </g>
                                    <g>
                                      <ellipse
                                        cx="6.5"
                                        cy="6.5"
                                        rx="1.55"
                                        ry="1.5"
                                      />
                                    </g>
                                  </svg>
                                </p>
                              </a>
                              <span data-text="Linkedin" id="Attlinkedin">{{
                                attendee.LinkedIn
                              }}</span>
                              <input
                                class="profile-edit-box"
                                title="Linkedin"
                                type="text"
                                v-model="attendee.LinkedIn"
                                placeholder="Linkedin"
                                @change="
                                  Liveupdate('LinkedIn has been Updated')
                                "
                              />
                            </li>
                          </ul>
                        </div>

                        <p
                          class="mx-2 prof-website"
                          title="Website"
                          v-show="showWebsite"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                          >
                            <path
                              id="website.svg"
                              fill="#aeb2ba"
                              style="fill-rule: evenodd"
                              class="cls-1"
                              d="M1801,560.007a8.007,8.007,0,1,1,8.01-8.007A8.011,8.011,0,0,1,1801,560.007Zm-1.44-5.558a0.724,0.724,0,0,0-.26-0.753l-0.62-.5s-0.28-.4-0.47-0.753a7.982,7.982,0,0,0-.95-1.382,4.743,4.743,0,0,1-.31-2.449,1.7,1.7,0,0,0-.19-1.108,6.1,6.1,0,0,0,3.94,10.523,1.854,1.854,0,0,0,.08-0.749,10.236,10.236,0,0,1-1.16-1.57A4.877,4.877,0,0,1,1799.56,554.449Zm4.49-7.738-0.26.7a3.882,3.882,0,0,1,.66.691,1.352,1.352,0,0,1-.34,1.759c-0.79.454-2,.253-2.23,0.973s-0.13,1.175-1.29,1.036c0.55,0.481.76,0.691,0.76,0.691a1.29,1.29,0,0,1,1.09.063c0.4,0.322,1.17.783,1.45,1a1.952,1.952,0,0,0,.85.471,1.144,1.144,0,0,1,.88.534,1.375,1.375,0,0,0,.28.772A6.078,6.078,0,0,0,1804.05,546.711Z"
                              transform="translate(-1793 -544)"
                            />
                          </svg>
                          <a
                            id="Attwebsite"
                            target="_blank"
                            data-text="Website"
                            v-bind:href="attendee.Website"
                            class
                            >{{ attendee.Website }}</a
                          >
                          <input
                            class="profile-edit-box"
                            title="Website"
                            type="text"
                            v-model="attendee.Website"
                            placeholder="Website"
                            @change="Liveupdate('Website has been Updated')"
                          />
                        </p>
                      </div>

                      <div
                        v-show="isFromMainLobby"
                        class="scror-card-btn d-flex justify-content-between align-items-center"
                      >
                        <a
                          v-show="$store.state.client[0].id != 'C1649103310659'"
                          :class="
                            displayScorecardLinkInMyProfile || true
                              ? 'common-outlined-button mr-2 btn-btn-border text-center'
                              : 'full-btn-width common-outlined-button mr-2 btn-btn-border text-center'
                          "
                          href="#"
                          style="
                            background: #fff;
                            color: #1a73e8;
                            border: 1px solid #1a73e8;
                            font-weight: 400;
                            font-size: 16px;
                            height: 40px !important;
                          "
                          tabindex="2"
                          data-toggle="modal"
                          data-target="#change-pass-modal"
                          >{{ $t("myprofile.changePassword") }}</a
                        >
                        <a
                          v-if="displayScorecardLinkInMyProfile || true"
                          :class="
                            $store.state.client[0].id == 'C1649103310659'
                              ? 'w-100'
                              : ''
                          "
                          class="common-outlined-button btn-btn-border"
                          href="javascript:void(0);"
                          style="
                            background: none;
                            color: #1976d2;
                            border: 1px solid #1976d2;
                            font-weight: 400;
                            font-size: 16px;
                            height: 40px !important;
                          "
                          tabindex="1"
                          @click="goToMyAchievements()"
                          >{{ $t("myprofile.myAchievementsButton") }}</a
                        >
                      </div>
                      <p
                        v-show="isFromMainLobby"
                        class="edit-btn-set mt-3 text-center"
                      >
                        <v-btn
                          dark
                          color="#1a73e8"
                          large
                          id="btneditDetails"
                          @click.prevent="editDetails"
                          class="common-fill-button"
                          data-tag="profileEdit"
                          tabindex="3"
                          width="100%"
                        >
                          {{ $t("myprofile.editProfile") }}
                        </v-btn>
                        <!-- <v-btn text color="#007ab8" class="linkedin-sync"><v-icon size="25px" color="#007ab8" class="mr-1">mdi-linkedin</v-icon> Sync with Linkedin</v-btn> -->
                        <!-- <a
                      id="btneditDetails"
                      href="#"
                      @click.prevent="editDetails"
                      class="blue-button mt-6"
                      data-tag="profileEdit"
                      :style="
                        'background-color:' +
                        getTopMenuColor +
                        '; border:2px solid ' +
                        getTopMenuColor
                      "
                      ></a
                    > -->

                        <!-- <a
                      id="btnCancelsaveDetails"
                      style="display: none"
                      href="#"
                      @click.prevent="canceleditDetails"
                      class="blue-button btn-cancel edit-cancel"
                      data-tag="profilecancleEditDetails"
                      :style="
                        'background-color:' +
                        getTopMenuColor +
                        '; border:2px solid ' +
                        getTopMenuColor
                      "
                      >{{ $t("myprofile.cancel") }}</a
                    > -->
                        <v-btn
                          depressed
                          outlined
                          color="#1a73e8"
                          id="btnCancelsaveDetails"
                          style="display: none"
                          href="#"
                          @click.prevent="canceleditDetails"
                          data-tag="profilecancleEditDetails"
                          tabindex="5"
                        >
                          {{ $t("myprofile.cancel") }}
                        </v-btn>

                        <a
                          id="btnsaveDetails"
                          style="display: none"
                          href="#"
                          @click.prevent="
                            saveUserchanges($t('myprofile.profileupdatedalert'))
                          "
                          tabindex="4       "
                          class="update-prof-button ml-2"
                          data-tag="profileEditSave"
                          >{{ $t("myprofile.update") }}</a
                        >
                      </p>
                    </div>
                  </div>
                  <!--<div class="full-width mt-2" id="dvUpload" style="display:none;float:left;">
              <div class="sponsors-box-hld pb-4">
                <div class="top-img-box full-width py-4">
                  <upload></upload>
                </div>
              </div>
            </div>-->
                </div>
                <div v-if="isFromMainLobby" class="col-lg-9">
                  <div class="profile-switch-wrap p-0">
                    <div class="tab-sectionprofile">
                      <template>
                        <v-tabs
                          v-model="tabModal"
                          height="48px"
                          slider-color="#1c1d26"
                        >
                          <v-tab> PROFILE INFO </v-tab>

                          <v-tab v-if="showMyBoothsTab"> MY BOOTHS </v-tab>
                          <!-- <v-tab > MY QR CODE </v-tab> -->
                        </v-tabs>
                      </template>
                      <v-tabs-items v-model="tabModal">
                        <v-tab-item>
                          <div
                            class="profile-wrapper-des-right px-0"
                            style="box-shadow: none"
                          >
                            <div class="card">
                              <h5 class="mt-4">
                                {{ $t("myprofile.minibio") }}
                              </h5>
                              <!--<button type="button" v-on:click="linkdinImport" class="btn btn-LinkedIn">
                              <svg height="22px" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="22px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="linkedin__x2C__social__x2C__media_x2C__icons_x2C_"><g><path d="M425.619,86.346C382.172,42.9,322.258,16.066,255.965,16.066    c-66.297,0-126.212,26.834-169.65,70.279c-43.452,43.442-70.286,103.359-70.286,169.652c0,66.292,26.834,126.211,70.286,169.654    c43.438,43.447,103.353,70.281,169.65,70.281c66.293,0,126.207-26.834,169.654-70.281    c43.443-43.443,70.277-103.362,70.277-169.654C495.896,189.705,469.063,129.788,425.619,86.346z M412.332,412.365    c-39.993,40.126-95.251,64.835-156.367,64.835c-61.121,0-116.379-24.709-156.372-64.835    c-40.117-39.984-64.831-95.252-64.831-156.367c0-61.111,24.714-116.377,64.831-156.365C139.586,59.509,194.844,34.8,255.965,34.8    c61.116,0,116.374,24.709,156.367,64.833c40.121,39.988,64.831,95.254,64.831,156.365    C477.163,317.113,452.453,372.381,412.332,412.365z" style="fill:#fff;"/><polygon points="145,258.257 145,363 198,363 198,249.621 198,218 145,218   " style="fill:#fff;"/><path d="M310.3,218.666c-21.657,0-36.269,9.334-42.378,18.334H266v-19h-39v29.627V363h44v-70.331    c0-18.87,1.816-37.066,24.938-37.066c23.242,0,23.063,21.518,23.063,38.392V363h44v-78.039c0-7.443,0.221-14.946-0.574-21.325    C359.105,236.27,347.236,218.666,310.3,218.666z" style="fill:#fff;"/><path d="M172.931,147.722c-13.949,0-25.244,11.293-25.244,25.244c0,13.952,11.295,25.242,25.244,25.242    c13.95,0,25.24-11.29,25.24-25.242C198.17,159.015,186.88,147.722,172.931,147.722z" style="fill:#fff;"/></g></g><g id="Layer_1"/></svg>
                              Import from LinkedIn
                            </button>-->
                              <div class="edit-panel-cvr">
                                <!-- <p id="AttProfile">{{attendee.Profile}}</p> -->

                                <p
                                  id="AttProfile"
                                  v-html="attendee.Profile"
                                ></p>
                                <!-- <p id="AttProfile"></p> -->
                                <div class="edit-icon">
                                  <v-btn
                                    v-show="isFromMainLobby"
                                    @click.prevent="editProfile"
                                    v-if="!editBtnClick"
                                    tabindex="7"
                                    ><svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                    >
                                      <path
                                        id="edit.svg"
                                        style="
                                          fill: #6a6d70;
                                          fill-rule: evenodd;
                                        "
                                        d="M2793.7,315.159L2784.06,325H2779v-5.238l9.99-9.485a0.992,0.992,0,0,1,1.43,0l3.28,3.411A1.071,1.071,0,0,1,2793.7,315.159Zm-4-2.676-8.68,8.318v2.12h2.03l8.51-8.5ZM2776,328h15v-7h2v7a2,2,0,0,1-2,2h-15a2,2,0,0,1-2-2V313a2,2,0,0,1,2-2h7v2h-7v15Z"
                                        transform="translate(-2774 -310)"
                                      />
                                    </svg>
                                    <span class="pl-2">Edit</span> </v-btn
                                  ><v-btn
                                    v-show="isFromMainLobby"
                                    @click.prevent="saveProfile"
                                    v-if="editBtnClick"
                                    tabindex="8"
                                    ><svg
                                      id="save.svg"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="30"
                                      height="30"
                                      viewBox="0 0 30 30"
                                    >
                                      <circle
                                        class="cls-1"
                                        cx="15"
                                        cy="15"
                                        r="15"
                                        style="fill: #71b84a"
                                      />
                                      <path
                                        style="fill: #fff; fill-rule: evenodd"
                                        id="_64-interface_-_arrow_bottom"
                                        data-name="64-interface - arrow bottom"
                                        class="cls-2"
                                        d="M4327.68,317.773l-7.3,6.744a0.579,0.579,0,0,1-.07.176,1.054,1.054,0,0,1-.8.3,1.074,1.074,0,0,1-.8-0.3,1.01,1.01,0,0,1-.07-0.173l-3.34-3.667a1.033,1.033,0,0,1,0-1.485,1.082,1.082,0,0,1,1.51,0l2.7,2.985,6.66-6.062a1.079,1.079,0,0,1,1.51,0A1.03,1.03,0,0,1,4327.68,317.773Z"
                                        transform="translate(-4306 -305)"
                                      />
                                    </svg>
                                    <span class="pl-2">Save</span>
                                  </v-btn>
                                  <!--<a
                                  id="btneditProfile"
                                  href="#"
                                  @click.prevent="editProfile"
                                  data-tag="profileEditDescription"
                                >
                                  <span
                                    class="edit_ico"
                                    data-toggle="tooltip"
                                    data-placement
                                    title="Edit"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                    >
                                      <path
                                        id="edit.svg"
                                        style="fill: #6a6d70; fill-rule: evenodd"
                                        d="M2793.7,315.159L2784.06,325H2779v-5.238l9.99-9.485a0.992,0.992,0,0,1,1.43,0l3.28,3.411A1.071,1.071,0,0,1,2793.7,315.159Zm-4-2.676-8.68,8.318v2.12h2.03l8.51-8.5ZM2776,328h15v-7h2v7a2,2,0,0,1-2,2h-15a2,2,0,0,1-2-2V313a2,2,0,0,1,2-2h7v2h-7v15Z"
                                        transform="translate(-2774 -310)"
                                      />
                                    </svg>
                                  </span>
                                </a>-->
                                  <!--<a
                                  id="btnsaveProfile"
                                  style="display: none"
                                  href="#"
                                  @click.prevent="saveProfile"
                                  data-tag="profileDesSave"
                                >
                                  <span
                                    class="edit_ico"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Save"
                                  >
                                    <svg
                                      id="save.svg"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="30"
                                      height="30"
                                      viewBox="0 0 30 30"
                                    >
                                      <circle
                                        class="cls-1"
                                        cx="15"
                                        cy="15"
                                        r="15"
                                        style="fill: #71b84a"
                                      />
                                      <path
                                        style="fill: #fff; fill-rule: evenodd"
                                        id="_64-interface_-_arrow_bottom"
                                        data-name="64-interface - arrow bottom"
                                        class="cls-2"
                                        d="M4327.68,317.773l-7.3,6.744a0.579,0.579,0,0,1-.07.176,1.054,1.054,0,0,1-.8.3,1.074,1.074,0,0,1-.8-0.3,1.01,1.01,0,0,1-.07-0.173l-3.34-3.667a1.033,1.033,0,0,1,0-1.485,1.082,1.082,0,0,1,1.51,0l2.7,2.985,6.66-6.062a1.079,1.079,0,0,1,1.51,0A1.03,1.03,0,0,1,4327.68,317.773Z"
                                        transform="translate(-4306 -305)"
                                      />
                                    </svg>
                                  </span>
                                </a>-->
                                </div>
                              </div>
                            </div>
                            <div class="card py-md-4 mb-4">
                              <!-- <h4>BNI Category</h4> -->
                              <h4 v-show="isFromMainLobby">
                                {{ $t("myprofile.searchKeyword") }}
                              </h4>
                              <div
                                v-show="isFromMainLobby"
                                class="d-flex justify-content-between bni-cat"
                              >
                                <p v-show="isFromMainLobby" class="m-0">
                                  <input-tag
                                    tabindex="9"
                                    id="txtTags"
                                    class="w-full mt-4"
                                    placeholder="Add multiple keywords separated by comma. eg: marketing, branding, technology"
                                    v-model="attendeeTags"
                                    name="Tags"
                                    @keyup.enter="SaveTags"
                                  ></input-tag>
                                  <!-- <input
                                    type="text"
                                    value
                                    id="txtTags"
                                    :placeholder="$t('myprofile.addkeyword')"
                                    data-tag="profileTagSearch"
                                    @keyup.enter="SaveTags"
                                  /> -->
                                </p>
                                <div
                                  v-show="isFromMainLobby"
                                  class="text-right mt-3 ml-md-3"
                                >
                                  <v-btn
                                    height="45px"
                                    id="btnAddTags"
                                    depressed
                                    color="#1a73e8"
                                    width="130px"
                                    large
                                    @click.prevent="SaveTags"
                                    class="submit-button mt-1"
                                    tabindex="10"
                                    data-tag="profileAddTag"
                                  >
                                    {{ $t("myprofile.add") }}
                                  </v-btn>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <div class="profile-expo-booth-listing-wrap">
                              <div
                                class="profile-single-booth-sec"
                                v-for="exhibitor in allExhibitorsList"
                                v-bind:key="exhibitor.ExhibitorId"
                              >
                                <div
                                  class="d-flex justify-content-start align-items-center"
                                >
                                  <div
                                    class="profile-booth-image-sec"
                                    v-if="exhibitor.HotspotImageURL"
                                  >
                                    <img :src="exhibitor.HotspotImageURL" />
                                  </div>
                                  <div class="profile-booth-image-sec" v-else>
                                    <img
                                      src="../assets/Images/reg-ico/img-icon.svg"
                                      title="image"
                                      width="64px"
                                    />
                                  </div>
                                  <div class="profile-booth-details-sec">
                                    <h4>{{ exhibitor.Name }}</h4>

                                    <p v-html="exhibitor.Profile"></p>
                                  </div>
                                </div>
                                <div class="profile-booth-manage-butn">
                                  <v-btn
                                    v-if="!lockUnLockExpoManage"
                                    dark
                                    class="save-standard"
                                    color="#1a73e8"
                                    @click="toExpoList(exhibitor.ExhibitorId)"
                                    >Manage Booth</v-btn
                                  >
                                  <v-btn
                                    v-else
                                    disabled
                                    depressed
                                    class="save-standard"
                                    color="#c3c3c3"
                                    ><v-icon color=" darken-2"
                                      >mdi-lock-outline</v-icon
                                    >
                                    Manage Booth</v-btn
                                  >
                                </div>
                              </div>
                            </div>
                          </v-card>
                        </v-tab-item>

                        <!-- <v-tab-item>
                          <div class="qr-code-section">
                            <div class="qr-hld">
                              <img src="../assets/Images/my-qr.jpg"/>
                            </div>
                            <p>Scan the QR code to get my business card</p>

                          </div> 
                        </v-tab-item>-->
                      </v-tabs-items>
                    </div>

                    <!-- </v-tab-item> -->
                    <!-- </v-tabs> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!------------------>

        <br />
        <div class="row mt-3">
          <div class="col-lg-10 col-md-12 offset-lg-1 offset-md-0 p-0">
            <div v-if="isFromMainLobby" class="row" v-show="showAdditionalInfo">
              <div class="col-lg-3">
                <div></div>
              </div>
              <div class="col-lg-9">
                <div
                  class="px-2 py-3 additional_Info"
                  style="
                    background-color: #ffffff;
                    border-radius: 10px;
                    box-shadow: rgb(0 0 0 / 10%) 0px 0.0625rem 0.125rem,
                      rgb(0 0 0 / 15%) 0px 0.25rem 1rem -0.125rem;
                  "
                >
                  <h4 class="pl-2">More Info</h4>
                  <div id="divDynamicContent" class="profile-wrapper-des-right">
                    <div class="card">
                      <h5>{{ $t("myprofile.otherinfo") }}</h5>
                    </div>
                    <!-- <div class="edit-panel-cvr">
                <div>
                  <span>Email</span>
                  <span>:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span>dipesh@webspiders.com</span>
                </div>
                    </div>-->
                    <!-- <div class="edit-panel-cvr">
                <div>
                  <span>Phone Number</span>
                  <span>:</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span>7989545555</span>
                </div>
                    </div>-->
                  </div>
                </div>
              </div>
            </div>
            <!-- dynamic content Ends -->
          </div>
        </div>
      </div>

      <div class="info-alert-msg"></div>
    </section>

    <footer v-if="isFromMainLobby" class="footer-hld text-center">
      <p>{{ $t("myprofile.copyright") }}</p>
    </footer>
    <!--=== Footer End ===-->

    <div class="loader-profile">
      <svg
        width="65px"
        height="65px"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 33 33;270 33 33"
            begin="0s"
            dur="1.4s"
            fill="freeze"
            repeatCount="indefinite"
          />
          <circle
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
            stroke-dasharray="187"
            stroke-dashoffset="610"
          >
            <animate
              attributeName="stroke"
              values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
              begin="0s"
              dur="5.6s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 33 33;135 33 33;450 33 33"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <animate
              attributeName="stroke-dashoffset"
              values="187;46.75;187"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
          </circle>
        </g>
      </svg>
    </div>
    <!-------toster message start----->

    <div class="toster-mm-text">
      <span class="toster-msg">
        <i class="glyphicon glyphicon-ok-circle mm-icon"></i>
        <span>{{ $t("myprofile.sucessfullyadded") }}</span>
      </span>
    </div>
    <!------forgot pass popup--------->
    <div
      class="modal fade change-pass-btn"
      id="change-pass-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-show="isFromMainLobby" class="modal-title">
              <strong>{{ $t("myprofile.changepassword") }}</strong>
            </h5>
            <button
              v-show="isFromMainLobby"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <!--<div class="form-group">
                <label for="exampleInputEmail1">{{
                  $t("myprofile.currentpassword")
                }}</label>
                <input
                  type="password"
                  class="form-control"
                  id="txtCurrentPassword"
                  aria-describedby="emailHelp"
                  :placeholder="$t('myprofile.placeholdercurrentpwd')"
                />
              </div>-->
              <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
              <div class="form-group">
                <label for="exampleInputPassword1">{{
                  $t("myprofile.newpassword")
                }}</label>
                <input
                  type="password"
                  class="form-control"
                  id="txtNewPassword"
                  autocomplete="off"
                  :placeholder="$t('myprofile.placeholdernewpassword')"
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPassword1">{{
                  $t("myprofile.confirmpassword")
                }}</label>
                <input
                  type="password"
                  class="form-control"
                  id="txtConfirmNewPassword"
                  autocomplete="off"
                  :placeholder="$t('myprofile.placeholderconfirmPwd')"
                />
              </div>
              <span id="spnPwdLabel"></span>
              <p class="text-center">
                <button
                  v-show="isFromMainLobby"
                  type="button"
                  v-on:click="changePassword()"
                  class="blue-button mt-3"
                >
                  {{ $t("myprofile.submit") }}
                </button>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--------------->
    <!-- Success Modal -->
    <div class="modal fade all-modal" id="success-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              v-show="isFromMainLobby"
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <span
              class="success-icon d-flex justify-content-center align-items-center pa-2"
              style="text-transform: uppercase"
            >
              {{ getInitials() }}
            </span>
            <p>
              <strong>{{ $t("myprofile.changedsuccesfully") }}</strong>
            </p>

            <p>
              <span data-dismiss="modal" class="btn-pink sussecc-btn">{{
                $t("myprofile.great")
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Success Modal Ends-->

    <v-dialog
      v-model="showProfileEditPopup"
      width="800"
      height="800"
      persistent
    >
      <v-card
        class="profile-input-section-popup p-5"
        height="80vh"
        style="overflow: hidden; overflow-y: auto"
      >
        <div
          class="profile-pop-head pb-3 d-flex justify-content-between align-items-center"
        >
          <h3>My Profile</h3>
          <div style="position: absolute; right: 10px; top: 10px">
            <v-icon style="z-index: 2" size="32" @click="goBackToProfile()"
              >close</v-icon
            >
          </div>
        </div>
        <v-row>
          <v-col md="6" sm="12" v-if="basicFormKeys.includes('FirstName')">
            <label>{{ getDynamicLables("FirstName", basicFormData) }}</label>
            <input
              type="text"
              :value="attendeeData[0].FirstName"
              id="attendeeDetailsFirstName"
            />
          </v-col>
          <v-col md="6" sm="12" v-if="basicFormKeys.includes('LastName')">
            <label>{{ getDynamicLables("LastName", basicFormData) }}</label>
            <input
              type="text"
              :value="attendeeData[0].LastName"
              id="attendeeDetailsLastName"
            />
          </v-col>
          <v-col md="6" sm="12" v-if="basicFormKeys.includes('Title')">
            <label>Title</label>
            <input type="text" value="" />
          </v-col>
          <v-col md="6" sm="12" v-if="basicFormKeys.includes('Salutation')">
            <label>{{ getDynamicLables("Salutation", basicFormData) }}</label>
            <input type="text" value="" />
          </v-col>
          <v-col md="6" sm="12" v-if="basicFormKeys.includes('Email')">
            <label>{{ getDynamicLables("Email", basicFormData) }}</label>
            <input
              type="text"
              :value="attendeeData[0].Email"
              id="attendeeDetailsEmail"
              disabled
              readonly
            />
          </v-col>
          <v-col md="6" sm="12" v-if="basicFormKeys.includes('Mobile')">
            <label>{{ getDynamicLables("Mobile", basicFormData) }}</label>
            <input
              type="text"
              :value="attendeeData[0].Phone"
              id="attendeeDetailsPhone"
            />
          </v-col>
          <v-col md="6" sm="12" v-if="basicFormKeys.includes('Company')">
            <label>{{ getDynamicLables("Company", basicFormData) }}</label>
            <input
              type="text"
              :value="attendeeData[0].Company"
              id="attendeeDetailsCompany"
            />
          </v-col>
          <v-col md="6" sm="12" v-if="basicFormKeys.includes('MailingAddress')">
            <label>{{
              getDynamicLables("MailingAddress", basicFormData)
            }}</label>
            <input type="text" value="" />
          </v-col>
          <v-col md="6" sm="12" v-if="basicFormKeys.includes('Country')">
            <label>{{ getDynamicLables("Country", basicFormData) }}</label>
            <input type="text" value="" />
          </v-col>
          <v-col md="6" sm="12" v-if="basicFormKeys.includes('City')">
            <label>{{ getDynamicLables("City", basicFormData) }}</label>
            <input
              type="text"
              :value="attendeeData[0].City"
              id="attendeeDetailsCity"
            />
          </v-col>
          <v-col md="6" sm="12" v-if="basicFormKeys.includes('Zip')">
            <label>{{ getDynamicLables("Zip", basicFormData) }}</label>
            <input
              type="text"
              :value="attendeeData[0].Zip"
              id="attendeeDetailsZip"
            />
          </v-col>
          <v-col md="6" sm="12" v-if="basicFormKeys.includes('State')">
            <label>{{ getDynamicLables("State", basicFormData) }}</label>
            <input type="text" value="" />
          </v-col>

          <v-col md="6" sm="12" v-for="form in dynamicFormKeys" :key="form.cid">
            <label v-if="form.label != ''">{{ form.label }}</label>

            <input
              v-if="form.label != ''"
              type="text"
              :value="
                attendeeData[0].DynamicFields[form.cid] != undefined
                  ? attendeeData[0].DynamicFields[form.cid].value
                  : ''
              "
              :id="form.label"
            />
          </v-col>
        </v-row>

        <div
          class="d-flex justify-content-end align-items-center mt-1"
          v-if="basicFormKeys.length > 0"
        >
          <v-btn
            color="#6b6b6b"
            href="#"
            data-tag="profileEdit"
            tabindex="3"
            outlined
            class="mr-2"
            @click="goBackToProfile()"
          >
            Cancel
          </v-btn>
          <v-btn
            depressed
            color="#1a73e8"
            href="#"
            data-tag="profileEdit"
            tabindex="3"
            @click="saveUserDetails()"
          >
            Save
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import HelloWorld from "@/components/HelloWorld.vue";
// import Router from "vue-router";
// import firebase from "firebase";

import router from "../router";
import common from "../common.ts";
import store from "../store";
import firebase from "firebase";
import db from "../components/firebaseInit";
import analytics from "@/components/Analytics";
//import TopMenu from "@/components/TopMenu.vue";
//import Upload from "@/components/PhotoUpload.vue";
import APIs from "@/components/APIInit";
import InputTag from "vue-input-tag";
import jQuery from "jquery";

import https from "https";

import axios from "axios";
import { bus } from "@/main";

let $ = jQuery;
const storageRef = firebase;

var vm;
export default {
  components: {
    //TopMenu //,
    //Upload
    InputTag,
  },
  data() {
    return {
      lockUnLockExpoManage: false,
      basicFormKeys: [],
      dynamicFormKeys: [],
      isFromMainLobby: false,
      showWebsite: false,
      showAdditionalInfo: false,
      attendeeData: [],
      attendeeTags: [],
      eventcollectionName: "",
      userId: "",
      userUpdated: false,
      attendeeUpdated: false,
      textColor: "black",
      editBtnClick: false,
      displayScorecardLinkInMyProfile: false,
      showProfileEditPopup: false,
      basicFormData: [],
      tabModal: 0,
      allExhibitorsList: [],
      showMyBoothsTab: false,
      showProfileLoader: true,
    };
  },
  computed: {
    getTopMenuColor() {
      var color = $("#topmenu").css("background-color");
      console.log(color);
      if (color == "rgb(255, 255, 255)") {
        color = "grey";
      }
      return color;
    },
  },
  async mounted() {
    var data = {
      showUserWelcomeLoader: false,
    };

    bus.$emit("setUserWelcomeLoader", data);
    this.fetchExhibitorsList();
    this.fetchExhibitorSettings();
    this.isFromMainLobby = !(
      this.$store.state.DefaultLoginLandingPage == "/clientLobby"
    );
    vm = this;
    document.getElementById("spnPwdLabel").innerHTML = "";

    // $("#topmenu").show();
    // $("#leftmenu").show();
    $("#btnAddUserView").click();
    vm.scroll();
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //-------------dynamic font selection --------------------------------------
    if (obj.EventFont != undefined) {
      if (obj.EventFont.length > 0) {
        debugger;
        var urlpath = "";
        if (obj.EventFont[0].FontPath != "") {
          if (obj.EventFont[0].FontFamily != "") {
            urlpath = obj.EventFont[0].FontPath;

            var newStyle = document.createElement("style");
            newStyle.appendChild(
              document.createTextNode(
                "\
@font-face {\
    font-family: " +
                  obj.EventFont[0].FontFamily +
                  ";\
    src:" +
                  urlpath +
                  " ;\
}\
"
              )
            );

            document.head.appendChild(newStyle);

            $(
              "<style>* { font-family: '" +
                obj.EventFont[0].FontFamily +
                "' !important }</style>"
            ).appendTo("head");
          }
        } else {
          $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
            "head"
          );
        }
      }
    }
    //-------------dynamic font selection --------------------------------------
    //-------------------FAVICONJOB------------------------------------------------------------
    debugger;
    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
    //----------------------------------------------------------------------------------
    //-------Page Title-------------
    document.title = "My Profile - " + obj.eventname;
    /*++++++++ Header color Brancing JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

    var brandingData;
    try {
      brandingData = await this.getBrandingJSONDetails(
        obj.eventcollectionname + "/Branding/Branding.json"
      );
      if (brandingData.data != undefined) {
        if (brandingData.data.EventInfo != undefined) {
          if (brandingData.data.EventInfo.BodyTextColor != undefined) {
            self.textColor = brandingData.data.EventInfo.BodyTextColor;
          } else {
            self.textColor = "black !important";
          }
        } else {
          self.textColor = "black !important";
        }
        $("#headerText").css("color", self.textColor);
      }
    } catch (e) {
      console.log("Error in Branding Json Fetch--", e);
    }
    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);

    $("#sectionId").css(
      "background-image",
      "url(" + vm.getCDNUrl(obj.EventBranding[0].eventBGImage) + ")"
    );

    vm.userId = obj.user[0].id;
    vm.eventcollectionname = obj.eventcollectionname;
    this.attendeeData = [];
    this.displayAttendees();
    vm.getLeaderBoardSettings(vm.eventcollectionname);
    if (vm.$route.path.includes("editable")) {
      vm.getDynamicFormDetails();
      vm.showProfileEditPopup = true;
    }
    console.log("rrr====", vm.$route);

    if (vm.$route.fullPath.includes("#mybooth")) {
      vm.tabModal = 1;
    }
  },

  methods: {
    fetchExhibitorSettings() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname !== undefined) {
        if (obj.eventcollectionname !== "") {
          db.collection(obj.eventcollectionname)
            .doc("Settings")
            .collection("Exhibitor")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                console.log("datattt>>>", doc.data());
                if (doc.data().LockExhibitorBoothSetup) {
                  vm.lockUnLockExpoManage = doc.data().LockExhibitorBoothSetup;
                }
              });
            })
            .catch((error) => {
              alert(error);
            });
        }
      }
    },
    fetchExhibitorsList() {
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + this.getSessionToken(),
        instanceId: "OA_UAT",
        clientId: this.$store.state.client[0].id,
        eventId: this.$store.state.eventid,
      };

      axios
        .get(APIs.ExhibitorSelfServiceFetchApi, { headers: headers })
        .then((response) => {
          console.log("response====", response);
          response.data.results.map((expo) => {
            console.log("length", expo.MappedContacts.length);
            if (expo && expo.MappedContacts.length > 0) {
              console.log("length==", expo.MappedContacts.length);
              expo.MappedContacts.map((contact) => {
                if (contact.Email == this.$store.state.user[0].Email) {
                  this.allExhibitorsList.push(expo);
                  this.showMyBoothsTab = true;
                } else if (
                  expo.Email == this.$store.state.user[0].Email &&
                  contact.Email != this.$store.state.user[0].Email
                ) {
                  this.allExhibitorsList.push(expo);
                  this.showMyBoothsTab = true;
                }
              });
              if (this.showMyBoothsTab) {
                if (vm.$route.fullPath.includes("#mybooth")) {
                  vm.tabModal = 1;
                }
              }
            }
          });
          if (this.allExhibitorsList && this.allExhibitorsList.length == 1) {
            //alert(vm.lockUnLockExpoManage);
            if (vm.$route.fullPath.includes("#mybooth")) {
              if (!vm.lockUnLockExpoManage) {
                this.toExpoList(this.allExhibitorsList[0].ExhibitorId);
              }
            }
          }
          this.showProfileLoader = false;
        })
        .catch((error) => {
          this.showProfileLoader = false;
          console.error("There was an error editing the record: " + error);
        });
    },

    toExpoList(exhibitorid) {
      router.push("/expo-studio/" + exhibitorid);
      bus.$emit("toggleLoader", true);
    },

    goBackToProfile() {
      this.showProfileEditPopup = false;
      this.$router.push("/myprofile");
    },
    saveUserDetails() {
      console.log("inside>>>>");
      bus.$emit("toggleLoader", true);
      debugger;

      var firstName =
        document.getElementById("attendeeDetailsFirstName") != null
          ? document.getElementById("attendeeDetailsFirstName").value
          : "";
      var lastName =
        document.getElementById("attendeeDetailsLastName") != null
          ? document.getElementById("attendeeDetailsLastName").value
          : "";

      var phone =
        document.getElementById("attendeeDetailsPhone") != null
          ? document.getElementById("attendeeDetailsPhone").value
          : "";
      var company =
        document.getElementById("attendeeDetailsCompany") != null
          ? document.getElementById("attendeeDetailsCompany").value
          : "";

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var attendeeRef = db
        .collection(obj.eventcollectionname + "/AttendeeList/Attendees")
        .doc(obj.user[0].id);

      var userRef = db.collection("OA_UAT/UserList/Users").doc(obj.user[0].id);

      const promises = [];
      attendeeRef
        .get()
        .then(async (doc) => {
          debugger;

          console.log("dynamic form====", vm.dynamicFormKeys);

          if (vm.dynamicFormKeys.length > 0) {
            console.log("test it=====", doc.data());

            var dynamicFormData = doc.data().DynamicFields;

            if (
              dynamicFormData != undefined &&
              dynamicFormData[vm.dynamicFormKeys[0].cid] == undefined
            ) {
              //   dynamicFormData[vm.dynamicFormKeys[0].cid]["value"] =
              // document.getElementById('Name of School').value;

              dynamicFormData[vm.dynamicFormKeys[0].cid] = {
                des: "",
                field_type: "text",
                index: 1,
                label: "Name of School",
                value: document.getElementById("Name of School").value,
              };

              // dynamicFormData.push(vm.dynamicFormKeys[0].cid);
            } else {
              dynamicFormData[vm.dynamicFormKeys[0].cid]["value"] =
                document.getElementById("Name of School").value;
            }

            if (dynamicFormData != undefined) {
              await attendeeRef.set(
                { DynamicFields: dynamicFormData },
                { merge: true }
              );
            }

            // }
          }

          console.log("firstName====", firstName);
          console.log("lastName====", lastName);
          console.log("phone====", phone);
          console.log("company====", company);

          debugger;
          promises.push(
            doc.ref.update({
              Name: firstName.trim() + " " + lastName.trim(),
              FirstName: firstName.trim(),
              LastName: lastName.trim(),
              Phone:
                phone != ""
                  ? phone.trim()
                  : obj.user[0].phone != null
                  ? obj.user[0].phone
                  : "",
              Company: company,
            })
          );
          return Promise.all(promises);
          // });
        })
        .then(() => {
          console.log("Successfully updated the record");

          userRef
            .get()
            .then((doc) => {
              promises.push(
                doc.ref.update({
                  Name: firstName.trim() + " " + lastName.trim(),
                  FirstName: firstName.trim(),
                  LastName: lastName.trim(),
                  Company: company,
                  // Phone: phone != '' ? phone.trim() : obj.user[0].phone != null ? obj.user[0].phone : '',
                })
              );

              var obj = JSON.parse(window.localStorage.getItem("my-app"));
              store.commit("addUser", {
                id: obj.user[0].id,
                Email: obj.user[0].Email,
                //name: name,
                name: firstName.trim() + " " + lastName.trim(),
                fname: firstName,
                lname: lastName,
                profilepic: obj.user[0].profilepic,
                company: obj.user[0].company,
                title: obj.user[0].title,
                phone:
                  phone != ""
                    ? phone.trim()
                    : obj.user[0].phone != null
                    ? obj.user[0].phone
                    : "",
              });
              return Promise.all(promises);
              //});
            })
            .then(() => {
              $(".my-profile .dropbtn").text(firstName.trim());
              bus.$emit("toggleLoader", false);
              this.showSnackbar("Profile updated Succesfully!");
              this.showProfileEditPopup = false;
              this.$router.push("/myprofile");
              location.reload();
              console.log("Successfully updated the record");
              //location.reload();
            })
            .catch((error) => {
              bus.$emit("toggleLoader", false);
              console.error("There was an error editing the record: " + error);
            });
        })
        .catch((error) => {
          bus.$emit("toggleLoader", false);
          console.error("There was an error editing the record: " + error);
        });
    },
    getDynamicLables(data, formData) {
      var label;
      formData.forEach(function (key) {
        if (key.key == data) {
          label = key.value;
          return label;
        }
      });
      return label ? label : data;
    },
    getDynamicFormDetails() {
      var self = this;

      var docRef = db
        .collection(vm.eventcollectionname)
        .doc("FormList")
        .collection("RegistrationForms");
      docRef
        .get()
        .then(function (querySnapshot) {
          if (querySnapshot.size > 0) {
            querySnapshot.forEach((doc) => {
              var data = doc.data();

              console.log("data>>>>>", data);

              if (data.IsPublished && !data.IsPublished) {
                Object.keys(data.BasicForm).forEach((key) => {
                  var base = data.BasicForm[key]["IsShow" + key];
                  var displayLabel = data.BasicForm[key][key + "DisplayLabel"];

                  if (displayLabel != undefined) {
                    self.basicFormData.push({ key: key, value: displayLabel });
                  }

                  if (key == "FirstName") {
                    if (
                      data.BasicForm[key].IsShowfName == true ||
                      data.BasicForm[key].showFirstName == true
                    ) {
                      self.basicFormData.push({
                        key: "FirstName",
                        value: data.BasicForm[key].firstNameDisplayLabel,
                      });
                      self.basicFormKeys.push(key);
                    }
                  } else if (key == "LastName") {
                    if (data.BasicForm[key].IsShowlName == true) {
                      self.basicFormData.push({
                        key: "LastName",
                        value: data.BasicForm[key].lastNameDisplayLabel,
                      });
                      self.basicFormKeys.push(key);
                    }
                  } else if (key == "Email") {
                    if (data.BasicForm[key].IsShowEmail == true) {
                      self.basicFormData.push({
                        key: "Email",
                        value: data.BasicForm[key].emailDisplayLabel,
                      });
                      self.basicFormKeys.push(key);
                    }
                  } else if (key == "Mobile") {
                    if (data.BasicForm[key].IsShowMobile == true) {
                      self.basicFormData.push({
                        key: "Mobile",
                        value: data.BasicForm[key].mobileDisplayLabel,
                      });
                      self.basicFormKeys.push(key);
                    }
                  }
                  if (base) {
                    self.basicFormKeys.push(key);
                  }
                });

                Object.keys(data.DynamicFieldsJson).forEach((key) => {
                  if (data.DynamicFieldsJson[key].field_type == "text") {
                    self.dynamicFormKeys.push(data.DynamicFieldsJson[key]);
                  }
                });
              } else {
                self.basicFormKeys = [
                  "FirstName",
                  "LastName",
                  "Email",
                  "Mobile",
                ];
              }
            });
          } else {
            self.basicFormKeys = ["FirstName", "LastName", "Email", "Mobile"];
          }
        })
        .catch(function (error) {
          console.log("Error fetching Survey Form:", error);
        });
    },
    getInitials() {
      return common.getInitials(this.$store.state.user[0].name);
    },
    goToMyAchievements() {
      router.push("/leaderboard/my-achievements");
    },
    changePassword() {
      document.getElementById("spnPwdLabel").innerHTML = "";
      //alert("changePassword");
      // var reg = /((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+[0-9a-z]+$/i;
      // var reg2 = /[^a-zd]/i;

      //if (document.getElementById("txtCurrentPassword").value == "") {
      //  // alert("Current Password cant be blank.");
      //  document.getElementById("spnPwdLabel").innerHTML = vm.$t(
      //    "myprofile.currentpwdvalidmsg"
      //  );
      //  //"Current Password cant be blank.";
      //  $("#spnPwdLabel").css("color", "red");
      //  return;
      //}
      if (document.getElementById("txtNewPassword").value == "") {
        // alert("New  Password cant be blank.");
        document.getElementById("spnPwdLabel").innerHTML = vm.$t(
          "myprofile.newpwdvalidmsg"
        );
        //"New  Password cant be blank.";
        $("#spnPwdLabel").css("color", "red");
        return;
      }
      if (document.getElementById("txtConfirmNewPassword").value == "") {
        document.getElementById("spnPwdLabel").innerHTML = vm.$t(
          "myprofile.confirmpwdvalidmsg"
        );
        //"The confirm password cant be blank.";
        $("#spnPwdLabel").css("color", "red");
        return;
      }
      //var inputCurrentPwd = document.getElementById("txtCurrentPassword").value;
      var newPassword = document.getElementById("txtNewPassword").value;
      var confirmPassword = document.getElementById(
        "txtConfirmNewPassword"
      ).value;
      /*  if (document.getElementById("txtNewPassword").value.length < 6) {
        
        document.getElementById("spnPwdLabel").innerHTML =
          "New password must be at least 6-8 characters long.";
        $("#spnPwdLabel").css("color", "red");
        return;
      }*/
      if (document.getElementById("txtNewPassword").value.length < 6) {
        document.getElementById("spnPwdLabel").innerHTML = vm.$t(
          "myprofile.placeholdernewpassword"
        );
        //"New password must be 6 characters long.";
        $("#spnPwdLabel").css("color", "red");
        return;
      }
      if (document.getElementById("txtNewPassword").value.length > 16) {
        document.getElementById("spnPwdLabel").innerHTML = vm.$t(
          "myprofile.placeholdernewpassword"
        );
        //"New password must be 6 characters long.";
        $("#spnPwdLabel").css("color", "red");
        return;
      }
      /*   if (document.getElementById("txtNewPassword").value.length > 8) {
        //alert("New password must be at least 6-8 characters long.");
        document.getElementById("spnPwdLabel").innerHTML =
          "New password must be at least 6-8 characters long.";
        $("#spnPwdLabel").css("color", "red");
        return;
      }*/

      // var vl = reg2.test(newPassword);
      // console.log(vl);
      debugger;
      /*  if (!newPassword.match(reg)) {
        // alert("New password must be alpha-numeric");
        document.getElementById("spnPwdLabel").innerHTML =
          "New password must be alpha-numeric";
        $("#spnPwdLabel").css("color", "red");
        return;
      }*/

      //-------------------- Confirm password ---------------------

      if (
        document.getElementById("txtConfirmNewPassword").value != newPassword
      ) {
        document.getElementById("spnPwdLabel").innerHTML = vm.$t(
          "myprofile.confirmandnewpwdmatchvalidmsg"
        );
        //"The confirm password does not match with new password.";
        $("#spnPwdLabel").css("color", "red");
        return;
      }
      //-----------------------------------------------------------

      //var obj = JSON.parse(window.localStorage.getItem("my-app"));
      //var currentPwd = "";
      //var attendeeRef = "";
      //var userRef = "";

      // attendeeRef = db
      //   .collection(obj.eventcollectionname)
      //   .doc("AttendeeList")
      //   .collection("Attendees")
      //   .where("AttendeeId", "==", obj.user[0].id);
      //attendeeRef = db
      //  .collection(obj.eventcollectionname + "/AttendeeList/Attendees")
      //  .doc(obj.user[0].id);

      /*db.collection("OA_UAT")
        .doc("UserList")
        .collection("Users")
        .where("UserId", "==", obj.user[0].id)  .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var data = doc.data();
            currentPwd = data.Password;
          });*/
      debugger;
      let headers = {
        Authorization: "Bearer " + vm.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        data: {
          password: newPassword,
          confirmPassword: confirmPassword,
          userId: vm.userId,
        },
      };
      axios
        .post(APIs.ChangePassword, requestData, { headers: headers })
        .then((response) => {
          debugger;
          if (response && response.data && response.data.status == 0) {
            $("#spnPwdLabel").css("color", "green");
            $("#spnPwdLabel").html(vm.$t("myprofile.changedsuccesfully"));
            setTimeout(() => {
              $("#change-pass-modal").modal("hide");
            }, 5000);
          } else {
            $("#spnPwdLabel").css("color", "red");
            $("#spnPwdLabel").html(vm.$t("myprofile.changedunsuccesfull"));
          }
        })
        .catch((error) => {
          $("#spnPwdLabel").css("color", "red");
          $("#spnPwdLabel").html(vm.$t("myprofile.changedunsuccesfull"));
          console.log("error===========", error);
          //console.log(error)
          //resolve({ status: 500, message: "Password Not Changed" });
        });

      //db.collection("OA_UAT/UserList/Users")
      //  .doc(obj.user[0].id)
      //  .get()
      //  .then((doc) => {
      //    if (doc.exists) {
      //      debugger;
      //      currentPwd = doc.data().Password;
      //    }

      //    if (inputCurrentPwd != currentPwd) {
      //      //  alert("Current password does not match.");
      //      document.getElementById("spnPwdLabel").innerHTML =
      //        "Current password does not match.";
      //      $("#spnPwdLabel").css("color", "red");
      //      document.getElementById("txtCurrentPassword").value = "";
      //      document.getElementById("txtNewPassword").value = "";
      //      document.getElementById("txtConfirmNewPassword").value = "";
      //      return;
      //    } else {
      //      // alert("Current password matched.");
      //      // return;
      //      //-----------------------------------------------------------------------
      //      const promises = [];
      //      debugger;
      //      /* db.collection("OA_UAT")
      //        .doc("UserList")
      //        .collection("Users")
      //        .where("UserId", "==", obj.user[0].id).get()
      //        .then((snap) => {
      //          snap.forEach((doc) => {
      //            promises.push(
      //              doc.ref.update({
      //                Password: newPassword,
      //              })
      //            );
      //          });*/
      //      db.collection("OA_UAT/UserList/Users")
      //        .doc(obj.user[0].id)
      //        .get()
      //        .then((doc) => {
      //          promises.push(
      //            doc.ref.update({
      //              Password: newPassword,
      //            })
      //          );
      //        })
      //        .then(() => {
      //          debugger;

      //          //------------------------User list update----------------------------------

      //          attendeeRef
      //            .get()
      //            .then((doc) => {
      //              promises.push(
      //                doc.ref.update({
      //                  Password: newPassword,
      //                })
      //              );
      //            })
      //            .then(() => {
      //              // document.getElementById("spnPwdLabel").innerHTML =
      //              //   "Password updated Successfully";
      //              $("#spnPwdLabel").css("color", "green");
      //              document.getElementById("txtCurrentPassword").value = "";
      //              document.getElementById("txtNewPassword").value = "";
      //              document.getElementById("txtConfirmNewPassword").value = "";

      //              $("#change-pass-modal").modal("hide");
      //              $("#success-modal").modal("show");
      //            })
      //            .catch((error) => {
      //              console.error(
      //                "There was an error editing the record: " + error
      //              );
      //            });

      //          //----------------------------------------------------------------------------
      //        })
      //        .catch((error) => {
      //          console.error(
      //            "There was an error updating the record: " + error
      //          );
      //        });
      //      //--------------------------------------------------------------------------
      //    }
      //  });

      /* attendeeRef
              .get()
              .then((snap) => {
                snap.forEach((doc) => {
                  promises.push(
                    doc.ref.update({

                    });
                });

              });

          */
    },
    openUpload() {
      $("#fuProfile").trigger("click");
    },
    onFileChange(e) {
      console.log("e-=====", e);
      vm.userUpdated = false;
      vm.attendeeUpdated = false;
      debugger;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      //this.createImage(files[0]);

      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var metadata = {
          contentType: file.type,
        };

        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          // invalid file type code goes here.
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        $(".loader-profile").addClass("show");

        storageRef
          .storage()
          .ref()
          .child(
            vm.eventcollectionname +
              "/Attendees/" +
              vm.userId +
              "_" +
              new Date().getTime() +
              "_" +
              file.name
          )
          .put(file, metadata)
          .then(function (snapshot) {
            snapshot.ref
              .getDownloadURL()
              .then(function (imgURL) {
                vm.attendeeData[0].Image = imgURL;
                console.log(imgURL);
                var obj = JSON.parse(window.localStorage.getItem("my-app"));
                store.commit("addUser", {
                  id: obj.user[0].id,
                  Email: obj.user[0].Email,
                  //name: obj.user[0].name,
                  name:
                    obj.user[0].fname.trim() + " " + obj.user[0].lname.trim(),
                  fname: obj.user[0].fname.trim(),
                  lname: obj.user[0].lname.trim(),
                  profilepic:
                    imgURL == undefined ? obj.user[0].profilepic : imgURL,
                  company: obj.user[0].Compacompanyny,
                  title: obj.user[0].title,
                  phone: obj.user[0].phone,
                });

                db.collection(vm.eventcollectionname)
                  .doc("AttendeeList")
                  .collection("Attendees")
                  .doc(vm.userId)
                  .get()
                  .then(function (doc) {
                    if (doc.exists) {
                      doc.ref
                        .update({
                          ProfilePictureURL: imgURL,
                        })
                        .then(function () {
                          $(".my-profile img").attr("src", imgURL);
                          $(".info-alert-msg")
                            .text(vm.$t("myprofile.profilepicupdatealert"))
                            .addClass("show")
                            .fadeIn();
                          $(".loader-profile").removeClass("show");

                          setTimeout(function () {
                            $(".info-alert-msg").fadeOut().removeClass("show");
                          }, 2000);

                          console.log(imgURL);
                          console.log("Pic updated");
                          vm.attendeeUpdated = true;
                        })
                        .catch(function (error) {
                          console.error("Error : ", error);
                        });
                    }
                  });
                debugger;
                db.collection("OA_UAT")
                  .doc("UserList")
                  .collection("Users")
                  .doc(vm.userId)
                  .get()
                  .then(function (doc) {
                    debugger;
                    if (doc.exists) {
                      debugger;
                      doc.ref
                        .update({
                          ProfilePictureURL: imgURL,
                        })
                        .then(() => {
                          debugger;
                          vm.userUpdated = true;
                          console.log("User Successfully updated ");
                        })
                        .catch((error) => {
                          debugger;
                          console.error(
                            "There was an error editing the record: " + error
                          );
                        });
                    }
                  });
              })
              .then(() => {
                console.log("Successfully updated the record");
              })
              .catch((error) => {
                console.error(
                  "There was an error editing the record: " + error
                );
              });
          })
          .catch(function (error) {
            //$("body").addClass("loaded");
            // [START onfailure]
            console.error("Upload failed:", error);
            // [END onfailure]
          });
        // [END oncomplete]
      }
    },
    createImage(file) {
      console.log(file);
      //var image = new Image();
      //var reader = new FileReader();
      //var vm = this;
      //reader.onload = e => {
      //  vm.image = e.target.result;
      //};
      //reader.readAsDataURL(file);
    },
    displayAttendees() {
      debugger;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      console.log(obj.eventcollectionname);
      // db.collection(obj.eventcollectionname)
      //   .doc("AttendeeList")
      //   .collection("Attendees")
      //   .where("AttendeeId", "==", obj.user[0].id)
      let path = "";
      if (this.$store.state.DefaultLoginLandingPage == "/clientLobby") {
        path = "/OA_UAT/UserList/Users/";
      } else path = obj.eventcollectionname + "/AttendeeList/Attendees";
      db.collection(path)
        .doc(obj.user[0].id)
        .get()
        .then((doc) => {
          //querySnapshot.forEach((doc) => {
          debugger;
          var objAttendee = {
            id: doc.id,
            Name:
              doc.data().FirstName != undefined
                ? doc.data().FirstName.trim()
                : "" + " " + doc.data().LastName != undefined
                ? doc.data().LastName.trim()
                : "",
            Salutation:
              doc.data().Salutation != undefined ? doc.data().Salutation : "",
            Country: doc.data().Country != undefined ? doc.data().Country : "",
            FirstName:
              doc.data().FirstName != undefined
                ? doc.data().FirstName.trim()
                : "",
            LastName:
              doc.data().LastName != undefined
                ? doc.data().LastName.trim()
                : "",
            City: doc.data().City != undefined ? doc.data().City : "",
            RegistrationType:
              doc.data().RegistrationType != undefined
                ? doc.data().RegistrationType
                : "",
            Email: doc.data().Email,
            Image:
              doc.data().ProfilePictureURL != undefined
                ? this.getCDNUrl(doc.data().ProfilePictureURL)
                : "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2Favatar.jpg?alt=media",
            Profile: doc.data().Profile != undefined ? doc.data().Profile : "",
            Title:
              doc.data().Designation != undefined ? doc.data().Designation : "",
            Company: doc.data().Company != undefined ? doc.data().Company : "",
            Phone: doc.data().Phone != undefined ? doc.data().Phone : "",
            Tags: doc.data().Tags != undefined ? doc.data().Tags : [],
            SocialLinks: doc.data().SocialLinks,
            Website: doc.data().Website,
            DynamicFields:
              doc.data().DynamicFields != undefined
                ? doc.data().DynamicFields
                : [],
            MailingAddress:
              doc.data().MailingAddress != undefined
                ? doc.data().MailingAddress
                : "",
            State: doc.data().State != undefined ? doc.data().State : "",
            Zip: doc.data().Zip != undefined ? doc.data().Zip : "",
          };

          var tags = objAttendee.Tags;
          if (Array.isArray(tags) && tags.length > 0) {
            tags.forEach((tag) => {
              this.attendeeTags.push(tag);
            });
          }

          var sLinks = objAttendee.SocialLinks;
          debugger;
          if (sLinks != undefined) {
            sLinks.forEach((sLink) => {
              if (sLink["Facebook"] != undefined) {
                objAttendee.Facebook =
                  sLink["Facebook"] == undefined ? "" : sLink["Facebook"];
              }
              if (sLink["Twitter"] != undefined) {
                objAttendee.Twitter =
                  sLink["Twitter"] == undefined ? "" : sLink["Twitter"];
              }
              if (sLink["LinkedIn"] != undefined) {
                objAttendee.LinkedIn =
                  sLink["LinkedIn"] == undefined ? "" : sLink["LinkedIn"];
              }
              //if (sLink["GooglePlus"] != undefined) {
              //  objAttendee.GooglePlus =
              //    sLink["GooglePlus"] == undefined ? "" : sLink["GooglePlus"];
              //}
            });
          }
          //Facebook
          objAttendee.Facebook =
            objAttendee.Facebook == undefined
              ? ""
              : objAttendee.Facebook.trim().toLowerCase();
          objAttendee.Facebook =
            objAttendee.Facebook.indexOf("http://") >= 0
              ? objAttendee.Facebook.replace("http", "https")
              : objAttendee.Facebook;
          objAttendee.Facebook =
            objAttendee.Facebook == -1
              ? "https://" + objAttendee.Facebook
              : objAttendee.Facebook;

          //Twitter
          objAttendee.Twitter =
            objAttendee.Twitter == undefined
              ? ""
              : objAttendee.Twitter.trim().toLowerCase();
          objAttendee.Twitter =
            objAttendee.Twitter.indexOf("http://") >= 0
              ? objAttendee.Twitter.replace("http", "https")
              : objAttendee.Twitter;
          objAttendee.Twitter =
            objAttendee.Twitter == -1
              ? "https://" + objAttendee.Twitter
              : objAttendee.Twitter;

          //LinkedIn
          objAttendee.LinkedIn =
            objAttendee.LinkedIn == undefined
              ? ""
              : objAttendee.LinkedIn.trim().toLowerCase();
          objAttendee.LinkedIn =
            objAttendee.LinkedIn.indexOf("http://") >= 0
              ? objAttendee.LinkedIn.replace("http", "https")
              : objAttendee.LinkedIn;
          objAttendee.LinkedIn =
            objAttendee.LinkedIn == -1
              ? "https://" + objAttendee.LinkedIn
              : objAttendee.LinkedIn;

          //Website

          if (objAttendee.Website !== undefined) {
            if (objAttendee.Website !== "") {
              this.showWebsite = true;
            }
          }
          objAttendee.Website =
            objAttendee.Website == undefined
              ? ""
              : objAttendee.Website.trim().toLowerCase();
          objAttendee.Website =
            objAttendee.Website.indexOf("http://") >= 0
              ? objAttendee.Website.replace("http", "https")
              : objAttendee.Website;
          objAttendee.Website =
            objAttendee.Website == -1
              ? "https://" + objAttendee.Website
              : objAttendee.Website;

          this.attendeeData.push(objAttendee);

          var dynamicContent = "";
          var inicr = 0;
          debugger;
          $.each(vm.attendeeData[0].DynamicFields, function (k1, v1) {
            vm.showAdditionalInfo = true;
            console.log("index:- " + v1);
            $.each(vm.attendeeData[0].DynamicFields, function (k, v) {
              if (inicr == v.index) {
                //alert("key:"+k+" value:"+v);

                console.log("key:" + k + " value:" + v.field_type);
                if (v.field_type == "radio") {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><span>" +
                    v.label +
                    "</span><span>:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>" +
                    v.value +
                    "</span></div></div>";
                }

                if (v.field_type == "checkboxes") {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><span>" +
                    v.label +
                    "</span><span>:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>" +
                    v.value +
                    "</span></div></div>";
                }
                if (v.field_type == "text") {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><span>" +
                    v.label +
                    "</span><span>:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>" +
                    v.value +
                    "</span></div></div>";
                }
                if (v.field_type == "dropdown") {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><span>" +
                    v.label +
                    "</span><span>:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>" +
                    v.value +
                    "</span></div></div>";
                }
                if (v.field_type == "email") {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><span>" +
                    v.label +
                    "</span><span>:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>" +
                    v.value +
                    "</span></div></div>";
                }
                if (v.field_type == "paragraph") {
                  debugger;
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><span>" +
                    v.label +
                    "</span><span>:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>" +
                    v.value +
                    "</span></div></div>";
                }
              }
            });
            inicr++;

            //  for (var key in vm.model) {
            //           //var keys = Object();
            //           if (vm.model[key] != undefined && vm.model[key] != "") {
            //             var input = {};
            //             var field = vm.fields.filter(function (value) {
            //               return value.cid == key;
            //             });
            //             debugger;
            //             if (field.length > 0) {
            //               input.label = field[0].label;
            //               input.des = field[0].field_options.description;
            //             }
            //             input.value = vm.model[key];
            //             allInputs[key] = input;
            //           }
            //           //vm.model[allKeys[12]]
            //           //allInputs.push(keys);
            //         }
          });
          //------------------------------------------------------------------------------------
          $("#divDynamicContent").html("");
          $("#divDynamicContent").append(dynamicContent);
        })
        .catch((error) => {
          alert(error);
          // console.log("Error getting documents: ", error);
        });
    },
    setTopMenuUserImage: function (Image) {
      // alert(this.attendeeData.Image);
      //   var img = document.getElementById("userImageControl");
      $("#userImageControl").attr("src", Image);
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    editDetails: function () {
      debugger;
      debugger;

      vm.getDynamicFormDetails();
      vm.showProfileEditPopup = true;

      // var AttEmail = document.getElementById("AttEmail").innerText;
      // AttEmail = "Email: " + AttEmail;
      // document.getElementById("AttEmail").innerHTML = AttEmail;
      // //-------------------------------------------------------------------------

      // var AttCountry = document.getElementById("AttCountry").innerText;
      // AttCountry = "Country: " + AttCountry;
      // document.getElementById("AttCountry").innerHTML = AttCountry;
      // //-------------------------------------------------------------------------
      // var AttPhone = document.getElementById("AttPhone").innerText;
      // AttPhone = "Phone: " + AttPhone;
      // document.getElementById("AttPhone").innerHTML = AttPhone;
      // //-------------------------------------------------------------------------
      // var AttRegistrationType = document.getElementById(
      //   "AttRegistrationType"
      // ).innerText;
      // AttRegistrationType = "Registration Type: " + AttRegistrationType;
      // document.getElementById("AttRegistrationType").innerHTML =
      //   AttRegistrationType;
      // //-------------------------------------------------------------------------

      // var AttMailingAddress =
      //   document.getElementById("AttMailingAddress").innerText;
      // AttMailingAddress = "Mailing Address: " + AttMailingAddress;
      // document.getElementById("AttMailingAddress").innerHTML =
      //   AttMailingAddress;
      // //-------------------------------------------------------------------------
      // var AttState = document.getElementById("AttState").innerText;
      // AttState = "State: " + AttState;
      // document.getElementById("AttState").innerHTML = AttState;
      // //-------------------------------------------------------------------------

      // var AttCity = document.getElementById("AttCity").innerText;
      // AttCity = "City: " + AttCity;
      // document.getElementById("AttCity").innerHTML = AttCity;
      // //-------------------------------------------------------------------------
      // var AttZip = document.getElementById("AttZip").innerText;
      // AttZip = "Zip: " + AttZip;
      // document.getElementById("AttZip").innerHTML = AttZip;
      // //-------------------------------------------------------------------------
      // $("#profileSocial").addClass("showEdit");
      // document
      //   .getElementById("AttName")
      //   .setAttribute("contentEditable", "true");
      // document
      //   .getElementById("AttName_first")
      //   .setAttribute("contentEditable", "true");
      // document
      //   .getElementById("AttName_last")
      //   .setAttribute("contentEditable", "true");
      // document
      //   .getElementById("Atttitle")
      //   .setAttribute("contentEditable", "true");
      // document
      //   .getElementById("Attcompany")
      //   .setAttribute("contentEditable", "true");
      // document
      //   .getElementById("Attwebsite")
      //   .setAttribute("contentEditable", "true");

      // document
      //   .getElementById("Attfacebook")
      //   .setAttribute("contentEditable", "true");
      // document
      //   .getElementById("Atttwitter")
      //   .setAttribute("contentEditable", "true");
      // //document
      // //  .getElementById("Attgoogleplus")
      // //  .setAttribute("contentEditable", "true");
      // document
      //   .getElementById("Attlinkedin")
      //   .setAttribute("contentEditable", "true");

      // document.getElementById("AttName").focus();
      // document.getElementById("btnsaveDetails").style.display = "inline-block";
      // document.getElementById("btneditDetails").style.display = "none";
      // $("#btnCancelsaveDetails").show();
      // document.getElementById("dvUpload").style.display = "none";
      // //document.getElementById("profileSocial").classList.add("showEdit");
    },
    canceleditDetails: function () {
      $("#profileSocial").removeClass("showEdit");
      debugger;
      document
        .getElementById("AttName")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("AttName_first")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("AttName_last")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("Atttitle")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("Attcompany")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("Attwebsite")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("Attfacebook")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("Atttwitter")
        .setAttribute("contentEditable", "false");
      //document
      //  .getElementById("Attgoogleplus")
      //  .setAttribute("contentEditable", "false");
      document
        .getElementById("Attlinkedin")
        .setAttribute("contentEditable", "false");

      document.getElementById("AttName").focus();
      document.getElementById("btnsaveDetails").style.display = "none";
      document.getElementById("btneditDetails").style.display = "inline-block";
      $("#btnCancelsaveDetails").hide();

      //document.getElementById("profileSocial").classList.remove("showEdit");
      this.attendeeData = [];
      this.displayAttendees();
    },

    saveUserchanges: function (Placeholder) {
      var AttEmail = document.getElementById("AttEmail").innerText;
      var indxColon = AttEmail.indexOf(":");
      var startIndx = indxColon + 1;
      AttEmail = AttEmail.substring(startIndx, AttEmail.length);
      document.getElementById("AttEmail").innerText = AttEmail;
      //-------------------------------------------------------------------------
      var AttCountry = document.getElementById("AttCountry").innerText;
      var indxcountryColon = AttCountry.indexOf(":");
      var startcountryIndx = indxcountryColon + 1;
      AttCountry = AttCountry.substring(startcountryIndx, AttCountry.length);
      document.getElementById("AttCountry").innerText = AttCountry;
      //-------------------------------------------------------------------------

      var AttPhone = document.getElementById("AttPhone").innerText;
      var indxPhoneColon = AttPhone.indexOf(":");
      var startPhoneIndx = indxPhoneColon + 1;
      AttPhone = AttPhone.substring(startPhoneIndx, AttPhone.length);
      document.getElementById("AttPhone").innerText = AttPhone;
      //-------------------------------------------------------------------------
      var AttRegistrationType = document.getElementById(
        "AttRegistrationType"
      ).innerText;
      var indxRegistrationTypeColon = AttRegistrationType.indexOf(":");
      var startRegistrationTypeIndx = indxRegistrationTypeColon + 1;
      AttRegistrationType = AttRegistrationType.substring(
        startRegistrationTypeIndx,
        AttRegistrationType.length
      );
      document.getElementById("AttRegistrationType").innerText =
        AttRegistrationType;
      //-------------------------------------------------------------------------
      var AttMailingAddress =
        document.getElementById("AttMailingAddress").innerText;
      var indxMailingAddressColon = AttMailingAddress.indexOf(":");
      var startMailingAddressIndx = indxMailingAddressColon + 1;
      AttMailingAddress = AttMailingAddress.substring(
        startMailingAddressIndx,
        AttMailingAddress.length
      );
      document.getElementById("AttMailingAddress").innerText =
        AttMailingAddress;
      //-------------------------------------------------------------------------
      var AttState = document.getElementById("AttState").innerText;
      var indxStateColon = AttState.indexOf(":");
      var startStateIndx = indxStateColon + 1;
      AttState = AttState.substring(startStateIndx, AttState.length);
      document.getElementById("AttState").innerText = AttState;
      //-------------------------------------------------------------------------
      var AttCity = document.getElementById("AttCity").innerText;
      var indxCityColon = AttCity.indexOf(":");
      var startCityIndx = indxCityColon + 1;
      AttCity = AttCity.substring(startCityIndx, AttCity.length);
      document.getElementById("AttCity").innerText = AttCity;
      //-------------------------------------------------------------------------
      var AttZip = document.getElementById("AttZip").innerText;
      var indxZipColon = AttZip.indexOf(":");
      var startZipIndx = indxZipColon + 1;
      AttZip = AttZip.substring(startZipIndx, AttZip.length);
      document.getElementById("AttZip").innerText = AttZip;
      //-------------------------------------------------------------------------

      $(".info-alert-msg").text(Placeholder).addClass("show").fadeIn();
      setTimeout(function () {
        $(".info-alert-msg").fadeOut().removeClass("show");
      }, 4000);

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // var attendeeRef = db
      //   .collection(obj.eventcollectionname)
      //   .doc("AttendeeList")
      //   .collection("Attendees")
      //   .where("AttendeeId", "==", obj.user[0].id);

      var attendeeRef = db
        .collection(obj.eventcollectionname + "/AttendeeList/Attendees")
        .doc(obj.user[0].id);

      /*  var userRef = db
        .collection("OA_UAT")
        .doc("UserList")
        .collection("Users")
        .where("UserId", "==", obj.user[0].id);*/
      var userRef = db.collection("OA_UAT/UserList/Users").doc(obj.user[0].id);

      debugger;

      //var narr = name.split(" ");
      //var fname = narr[0];
      var fname = document.getElementById("AttName_first").innerText;
      //var lname = narr[1];
      var lname = document.getElementById("AttName_last").innerText;
      var name = fname.trim() + " " + lname.trim();
      if (name.trim() == "") {
        alert("Name is mandatory.");
        return false;
      }

      var company = document.getElementById("Attcompany").innerText.trim();
      var designation = document.getElementById("Atttitle").innerText.trim();
      var website = document.getElementById("Attwebsite").innerText.trim();
      if (website != "" && website.toLowerCase().indexOf("http") == -1) {
        website = "https://" + website;
      }
      var facebook = document.getElementById("Attfacebook").innerText.trim();
      if (facebook != "" && facebook.toLowerCase().indexOf("http") == -1) {
        facebook = "https://" + facebook;
      }
      var twitter = document.getElementById("Atttwitter").innerText.trim();
      if (twitter != "" && twitter.toLowerCase().indexOf("http") == -1) {
        twitter = "https://" + twitter;
      }
      //var googleplus = document
      //  .getElementById("Attgoogleplus")
      //  .innerText.trim();
      //if (
      //  googleplus != "" &&
      //  googleplus.toLowerCase().indexOf("http") == -1
      //) {
      //  googleplus = "https://" + googleplus;
      //}
      var linkedin = document.getElementById("Attlinkedin").innerText.trim();
      if (linkedin != "" && linkedin.toLowerCase().indexOf("http") == -1) {
        linkedin = "https://" + linkedin;
      }
      debugger;
      const promises = [];
      attendeeRef
        .get()
        .then((doc) => {
          // .then((snap) => {
          //  snap.forEach((doc) => {
          promises.push(
            doc.ref.update({
              Name: fname.trim() + " " + lname.trim(),
              FirstName: fname.trim(),
              LastName: lname.trim(),
              Company: company,
              Designation: designation,
              Website: website,
              SocialLinks: [
                {
                  Facebook: (facebook == undefined ? "" : facebook).trim(),
                },
                {
                  Twitter: (twitter == undefined ? "" : twitter).trim(),
                },
                //{
                //  GooglePlus: (googleplus == undefined
                //    ? ""
                //    : googleplus
                //  ).trim()
                //},
                {
                  LinkedIn: (linkedin == undefined ? "" : linkedin).trim(),
                },
              ],
            })
          );
          return Promise.all(promises);
          // });
        })
        .then(() => {
          console.log("Successfully updated the record");

          userRef
            .get()
            .then((doc) => {
              //.then((snap) => {
              //  snap.forEach((doc) => {
              promises.push(
                doc.ref.update({
                  Name: name.trim(),
                  FirstName: fname.trim(),
                  LastName: lname.trim(),
                  Company: company,
                  Designation: designation,
                  Website: website,
                  SocialLinks: [
                    {
                      Facebook: (facebook == undefined ? "" : facebook).trim(),
                    },
                    {
                      Twitter: (twitter == undefined ? "" : twitter).trim(),
                    },
                    {
                      GooglePlus: "",
                      //GooglePlus: (googleplus == undefined
                      //  ? ""
                      //  : googleplus
                      //).trim()
                    },
                    {
                      LinkedIn: (linkedin == undefined ? "" : linkedin).trim(),
                    },
                  ],
                })
              );
              var obj = JSON.parse(window.localStorage.getItem("my-app"));
              store.commit("addUser", {
                id: obj.user[0].id,
                Email: obj.user[0].Email,
                //name: name,
                name: name.trim(),
                fname: fname.trim(),
                lname: lname.trim(),
                profilepic: obj.user[0].profilepic,
                company: company,
                title: designation,
                phone: obj.user[0].phone,
              });
              return Promise.all(promises);
              //});
            })
            .then(() => {
              $(".my-profile .dropbtn").text(fname.trim());
              debugger;
              console.log("Successfully updated the record");
              //location.reload();
            })
            .catch((error) => {
              console.error("There was an error editing the record: " + error);
            });
        })
        .catch((error) => {
          console.error("There was an error editing the record: " + error);
        });

      document
        .getElementById("AttName")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("AttName_first")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("AttName_last")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("Atttitle")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("Attcompany")
        .setAttribute("contentEditable", "false");

      document
        .getElementById("Attwebsite")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("Attfacebook")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("Atttwitter")
        .setAttribute("contentEditable", "false");
      //document
      //  .getElementById("Attgoogleplus")
      //  .setAttribute("contentEditable", "false");
      document
        .getElementById("Attlinkedin")
        .setAttribute("contentEditable", "false");

      document.getElementById("AttName").focus();
      document.getElementById("btnsaveDetails").style.display = "none";
      $("#btnCancelsaveDetails").hide();
      document.getElementById("btneditDetails").style.display = "inline-block";

      $("#profileSocial").removeClass("showEdit");
      document.getElementById("anchFB").href =
        facebook == undefined ? "" : facebook;
      document.getElementById("anchTwit").href =
        twitter == undefined ? "" : twitter;
      document.getElementById("anchLinkedIn").href =
        linkedin == undefined ? "" : linkedin;
      document.getElementById("Attwebsite").href =
        website == undefined ? "" : website;

      //document.getElementById("profileSocial").classList.remove("showEdit");
    },

    Liveupdate: function (Placeholder) {
      $(".info-alert-msg").text(Placeholder).addClass("show").fadeIn();
      setTimeout(function () {
        $(".info-alert-msg").fadeOut().removeClass("show");
      }, 2000);

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      /* var attendeeRef = db
        .collection(obj.eventcollectionname)
        .doc("AttendeeList")
        .collection("Attendees")
        .where("AttendeeId", "==", obj.user[0].id);
      var userRef = db
        .collection("OA_UAT")
        .doc("UserList")
        .collection("Users")
        .where("UserId", "==", obj.user[0].id);*/
      var attendeeRef = db
        .collection(obj.eventcollectionname + "/AttendeeList/Attendees")
        .doc(obj.user[0].id);

      var userRef = db.collection("OA_UAT/UserList/Users").doc(obj.user[0].id);

      var fname = document.getElementById("AttName_first").innerText;
      var lname = document.getElementById("AttName_last").innerText;
      var name = fname.trim() + " " + lname.trim();
      var company = document.getElementById("Attcompany").innerText.trim();
      var designation = document.getElementById("Atttitle").innerText.trim();
      var website = document.getElementById("Attwebsite").innerText.trim();
      if (website != "" && website.toLowerCase().indexOf("http") == -1) {
        website = "https://" + website;
      }
      var facebook = document.getElementById("Attfacebook").innerText.trim();
      if (facebook != "" && facebook.toLowerCase().indexOf("http") == -1) {
        facebook = "https://" + facebook;
      }
      var twitter = document.getElementById("Atttwitter").innerText.trim();
      if (twitter != "" && twitter.toLowerCase().indexOf("http") == -1) {
        twitter = "https://" + twitter;
      }
      var linkedin = document.getElementById("Attlinkedin").innerText.trim();
      if (linkedin != "" && linkedin.toLowerCase().indexOf("http") == -1) {
        linkedin = "https://" + linkedin;
      }
      const promises = [];
      attendeeRef
        .get()
        .then((doc) => {
          // .then((snap) => {
          // snap.forEach((doc) => {
          promises.push(
            doc.ref.update({
              Name: fname.trim() + " " + lname.trim(),
              FirstName: fname.trim(),
              LastName: lname.trim(),
              Company: company,
              Designation: designation,
              Website: website,
              SocialLinks: [
                {
                  Facebook: (facebook == undefined ? "" : facebook).trim(),
                },
                {
                  Twitter: (twitter == undefined ? "" : twitter).trim(),
                },
                {
                  LinkedIn: (linkedin == undefined ? "" : linkedin).trim(),
                },
              ],
            })
          );
          return Promise.all(promises);
          //});
        })
        .then(() => {
          console.log("Successfully updated the record");
          userRef
            .get()
            .then((doc) => {
              //  .then((snap) => {
              // snap.forEach((doc) => {
              promises.push(
                doc.ref.update({
                  Name: name.trim(),
                  FirstName: fname.trim(),
                  LastName: lname.trim(),
                  Company: company,
                  Designation: designation,
                  Website: website,
                  SocialLinks: [
                    {
                      Facebook: (facebook == undefined ? "" : facebook).trim(),
                    },
                    {
                      Twitter: (twitter == undefined ? "" : twitter).trim(),
                    },
                    {
                      GooglePlus: "",
                    },
                    {
                      LinkedIn: (linkedin == undefined ? "" : linkedin).trim(),
                    },
                  ],
                })
              );
              var obj = JSON.parse(window.localStorage.getItem("my-app"));
              store.commit("addUser", {
                id: obj.user[0].id,
                Email: obj.user[0].Email,
                name: name.trim(), // obj.user[0].Name,
                fname: fname.trim(),
                lname: lname.trim(),
                profilepic: obj.user[0].profilepic,
                company: company,
                title: designation,
                phone: obj.user[0].phone,
              });
              return Promise.all(promises);
              // });
            })
            .then(() => {
              console.log("++" + fname);
              $(".my-profile .dropbtn").text(fname.trim());
              console.log("Successfully updated the record");
              // location.reload();
            })
            .catch((error) => {
              console.error("There was an error editing the record: " + error);
            });
        })
        .catch((error) => {
          console.error("There was an error editing the record: " + error);
        });
    },

    editProfile: function () {
      debugger;

      document
        .getElementById("AttProfile")
        .setAttribute("contentEditable", "true");

      document
        .getElementById("AttProfile")
        .setAttribute("style", "min-height: 100px");

      document.getElementById("AttProfile").focus();
      //document.getElementById("btnsaveProfile").style.display = "block";
      this.editBtnClick = true;
      //document.getElementById("btneditProfile").style.display = "none";
      //document.getElementById("btncancelProfile").style.display = "block";
      document.getElementById("dvUpload").style.display = "none";
    },
    canceleditProfile: function () {
      debugger;
      document
        .getElementById("AttProfile")
        .setAttribute("contentEditable", "false");
      document.getElementById("btnsaveProfile").style.display = "none";
      document.getElementById("btneditProfile").style.display = "block";
      //document.getElementById("btncancelProfile").style.display = "none";
    },
    saveProfile: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      /*var cRef = db
        .collection(obj.eventcollectionname)
        .doc("AttendeeList")
        .collection("Attendees")
        .where("AttendeeId", "==", obj.user[0].id);*/
      var cRef = db
        .collection(obj.eventcollectionname + "/AttendeeList/Attendees")
        .doc(obj.user[0].id);

      // var uRef = db
      //   .collection("OA_UAT")
      //   .doc("UserList")
      //   .collection("Users")
      //   .where("UserId", "==", obj.user[0].id);

      /* var userRef = db
        .collection("OA_UAT")
        .doc("UserList")
        .collection("Users")
        .where("UserId", "==", obj.user[0].id);*/

      var userRef = db.collection("OA_UAT/UserList/Users").doc(obj.user[0].id);

      debugger;
      var profile = document.getElementById("AttProfile").innerText;

      const promises = [];
      cRef
        .get()
        .then((doc) => {
          //.then((snap) => {
          //  snap.forEach((doc) => {
          promises.push(
            doc.ref.update({
              Profile: profile,
            })
          );
          return Promise.all(promises);
          // });
        })
        .then(() => {
          console.log("Successfully updated the record");

          //----------------------------------------------------------------------------------------

          userRef
            .get()
            .then((doc) => {
              // .then((snap) => {
              //  snap.forEach((doc) => {
              promises.push(
                doc.ref.update({
                  Profile: profile,
                })
              );

              return Promise.all(promises);
              //});
            })
            .then(() => {
              console.log("Successfully updated the record");
            })
            .catch((error) => {
              console.error("There was an error editing the record: " + error);
            });

          //----------------------------------------------------------------------------------------
        })
        .catch((error) => {
          console.error("There was an error editing the record: " + error);
        });
      document
        .getElementById("AttProfile")
        .setAttribute("contentEditable", "false");
      document
        .getElementById("AttProfile")
        .setAttribute("style", "min-height: 10px");
      this.editBtnClick = false;
      //document.getElementById("btnsaveProfile").style.display = "none";
      //document.getElementById("btncancelProfile").style.display = "none";
      //document.getElementById("btneditProfile").style.display = "block";
    },
    closeUpload: function () {
      document.getElementById("dvUpload").style.display = "none";
    },
    SaveTags: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var cRef = db
        .collection(obj.eventcollectionname + "/AttendeeList/Attendees")
        .doc(obj.user[0].id);

      if (this.attendeeTags.length > 0) {
        const promises = [];
        cRef
          .get()
          .then((doc) => {
            promises.push(
              doc.ref.update({
                Tags: this.attendeeTags,
              })
            );
            return Promise.all(promises);
          })
          .then(() => {
            $(".info-alert-msg")
              .text("Your Search Keyword is updated")
              .addClass("show")
              .fadeIn();
            setTimeout(function () {
              $(".info-alert-msg").fadeOut().removeClass("show");
            }, 4000);
          })
          .catch((error) => {
            console.error("There was an error editing the record: " + error);
          });
      } else {
        alert(vm.$t("myprofile.keywordleftblank"));
      }
    },
    deleteTags: function (val) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var newVal;
      /* var cRef = db
        .collection(obj.eventcollectionname)
        .doc("AttendeeList")
        .collection("Attendees")
        .where("AttendeeId", "==", obj.user[0].id);*/
      var cRef = db
        .collection(obj.eventcollectionname + "/AttendeeList/Attendees")
        .doc(obj.user[0].id);

      const promises = [];
      cRef
        .get()
        .then((doc) => {
          // .then((snap) => {
          // snap.forEach((doc) => {
          debugger;
          var tarr = doc.data().Tags.split(",");
          var i;
          newVal = "";
          for (i = 0; i < tarr.length; i++) {
            if (tarr[i] != val) {
              newVal += tarr[i] + ",";
            }
          }
          if (newVal.endsWith(",")) {
            newVal = newVal.substring(0, newVal.length - 1);
          }
          // promises.push(
          //   db
          //     .collection(obj.eventcollectionname)
          //     .doc("AttendeeList")
          //     .collection("Attendees")
          //     .doc(obj.user[0].id)
          //     .update({
          //       Tags: newVal,
          //     })
          // );
          promises.push(
            db
              .collection(obj.eventcollectionname + "/AttendeeList/Attendees")
              .doc(obj.user[0].id)
              .update({
                Tags: newVal,
              })
          );
          return Promise.all(promises);
          //});
        })
        .then(() => {
          console.log("Successfully updated the record");
          debugger;

          var tarr = newVal.split(",");
          var i;
          document.getElementById("dvTags").innerHTML = "";
          // vm.attendeeTags = vm.attendeeTags.filter(function (value) {
          //   value != "";
          // });
          // if (vm.attendeeTags.length > 0) {
          //   return;
          // }

          for (i = 0; i < tarr.length; i++) {
            if (tarr[i] !== "") {
              /* document.getElementById("dvTags").innerHTML +=
                "<span style='margin:2px;' class='badge badge-primary'>" +
                tarr[i] +
                "<button v-on:click='deleteTags('" +
                tarr[i] +
                "')'>&#10006;</button></span>";*/

              //----------------------------------------------------------------------------------
              debugger;
              if (tarr[i] != undefined) {
                var btnDelTagId = "btnDelTag" + (i + 1);
                $("#dvTags").append(
                  "<span style='margin:2px;' d-val='" +
                    tarr[i] +
                    "' class='badge badge-primary'>" +
                    tarr[i] +
                    "<button  id=" +
                    btnDelTagId +
                    "  data-tag='profileDeleteTag'  d-val='" +
                    tarr[i] +
                    "' >&#10006;</button></span>"
                );

                var inputEl = document.getElementById(btnDelTagId);
                if (inputEl != null) {
                  var dynamic_value = function () {
                    debugger;
                    // var ss = e.currentTarget.getAttribute("d-val");
                    // console.log(ss);
                    vm.deleteTags($(this).attr("d-val"));
                  };
                  inputEl.addEventListener("click", dynamic_value);
                }
              }
              //----------------------------------------------------------------------
            }
          }
          document.getElementById("txtTags").value = "";
        })
        .catch((error) => {
          console.error("There was an error editing the record: " + error);
        });
    },
    linkdinImport: function () {
      //debugger

      // var CLIENT_ID = "78ncaql532tryi"
      // var CLIENT_SECRET = "3VPsRrRPzClJifbG"
      // var REDIRECT_URI = "https://www.linkedin.com/company/web-spiders/"
      // var SCOPE = "r_liteprofile%20r_emailaddress"

      // var AUTHURL = "https://www.linkedin.com/oauth/v2/authorization"
      // var TOKENURL = "https://www.linkedin.com/oauth/v2/accessToken"

      const accessToken = "78ncaql532tryi";
      const options = {
        host: "api.linkedin.com",
        path: "/v2/me",
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "cache-control": "no-cache",
          "X-Restli-Protocol-Version": "2.0.0",
          "Access-Control-Allow-Origin": "http://localhost:8080",
        },
      };

      const profileRequest = https.request(options, function (res) {
        let data = "";
        res.on("data", (chunk) => {
          data += chunk;
        });

        res.on("end", () => {
          const profileData = JSON.parse(data);
          console.log(JSON.stringify(profileData, 0, 2));
        });
      });
      profileRequest.end();
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname.trim() + " " + obj.user[0].lname.trim(),
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname.trim() + " " + obj.user[0].lname.trim(),
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      this.AddAnalitics(event, "click");
    },
    scroll: function () {
      window.onscroll = () => {
        //alert("scroll");
        if (!self.IsSearchMode) {
          let bottomOfWindow =
            document.documentElement.scrollTop + window.innerHeight + 1 >=
            document.documentElement.offsetHeight;
          if (bottomOfWindow) {
            //this.AddAnalitics(event, "scroll");
          }
        }
      };
    },
    getLeaderBoardSettings(eventCollection) {
      vm.displayScorecardLinkInMyProfile = false;

      if (eventCollection) {
        db.collection(eventCollection)
          .doc("Settings")
          .collection("LeaderBoard")
          .doc("LeaderBoardSettings")
          .get()
          .then((doc) => {
            if (doc.exists) {
              var data = doc.data();
              if (data.DisplayScorecardLinkInMyProfile == true) {
                vm.displayScorecardLinkInMyProfile = true;
              }
            }
          })
          .catch(function (error) {
            console.log("Error : " + error);
          });
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&family=Titan+One&display=swap");
.profile-input-section-popup input[type="text"] {
  height: 42px;
  width: 100%;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  padding: 0 15px;
  font-size: 16px;
  color: #000;
}
.centerText {
  display: flex;
  justify-content: center;
}
.profile-wrapper-des-right {
  background: #fff;
  padding: 10px 15px;
}
.profile-wrapper-des-right .card {
  box-shadow: none !important;
  border: none !important;
  background: none !important;
}
#attendeeProfile.attendee-details-popup {
  display: flex;
}
.profile-wrapper-des-right,
.my-profile .attendee-list .sponsors-box-hld {
  height: 100% !important;
}
.my-profile .top-img-box {
  padding: 30px 0 !important;
}
.profile-wrapper-des-right {
  border-radius: 0 5px 5px 0;
  box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.1);
}
.my-profile .attendee-list .sponsors-box-hld {
  box-shadow: none;
  border: none;
  border-radius: 5px 0 0 5px;
}
.col-md-4.prof {
  padding-right: 0;
}
.my-profile .attendee-img-area.loading:after {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  content: "";
  border-radius: 50%;
  z-index: 2;
}
.my-profile .attendee-img-area .edit_ico {
  background: #cc1022;
  border: 3px solid #fff;
  width: 40px;
  height: 40px;
  z-index: 3;
}
.title-line {
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}
p#AttEmail {
  text-align: center;
}
.showEdit p#AttEmail[data-text="Email"] {
  text-align: left;
}
p#AttCountry,
p#AttPhone {
  text-align: center;
}
.title-line {
  letter-spacing: 0.5px;
}
.title-line h4 {
  margin: 0 !important;
  font-size: 16px !important;
  color: #858585;
}
.title-line p {
  font-size: 16px !important;
  color: #858585;
  padding-left: 4px !important;
}
.my-profile .sponsors-box-hld h3 {
  margin: 18px 10px 6px;
  font-size: 24px;
}
.blue-button:hover,
.blue-button:focus,
.blue-button {
  background: #cc1022;
  text-transform: uppercase;
  padding: 12px 30px !important;
  height: auto !important;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  border: 2px solid #cc1022;
}
.edit-icon {
  display: flex;
  flex-direction: row-reverse;
}
.edit-icon .edit_ico {
  background: none;
}
.edit-panel-cvr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding: 0px 0 12px 0;
}
.profile-wrapper-des-right p#AttProfile {
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0);
  max-height: 20vh;
  overflow: auto;
  text-align: justify;
}
.profile-wrapper-des-right p#AttProfile[contenteditable="true"] {
  border: 1px solid #ddd;
}
.bni-cat p {
  display: block;
  width: 100%;
}
.bni-cat p input#txtTags {
  border: 1px solid #ddd;
  width: 100%;
  padding: 10px 15px;
  height: 47px;
  margin-top: 5px;
  color: #969696;
}
.tag-bni-list {
  margin: 10px 0;
  margin-bottom: 30px;
}
.tag-bni-list span.badge {
  padding: 10px 10px 10px 15px;
  background: #f0f2f7;
  color: #353535;
  text-transform: capitalize;
  font-size: 14px;
  letter-spacing: 0.5px;
  border-radius: 20px;
  font-weight: 300;
}
.tag-bni-list span.badge button {
  color: #545454;
}
.socialLinkProf a[href=""] {
  display: none;
}
.showEdit#profileSocial .socialLinkProf ul li span a {
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  height: auto;
}
.attendee-list .sponsors-box-hld h4:empty + span {
  display: none;
}
.blue-button.btn-cancel.edit-cancel {
  background: transparent !important;
  color: #cc1022;
  border: 2px solid #cc1022;
}
.blue-button.btn-cancel.edit-cancel,
.blue-button.ml-2.edit-save {
  width: 100px !important;
  min-width: 1px !important;
  text-align: center;
}
@keyframes popTopUp {
  0% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0);
  }
}
.info-alert-msg {
  position: fixed;
  right: 0;
  left: 0;
  margin: auto;
  bottom: 30px;
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 15px 15px;
  letter-spacing: 1px;
  font-size: 14px;
  border-radius: 5px;
  display: none;
  max-width: 300px;
  text-align: center;
}
.info-alert-msg.show {
  animation: popTopUp 0.5s linear;
}
.btn.btn-LinkedIn {
  position: absolute;
  right: 15px;
  background: #003f67;
  top: 18px;
  color: #fff;
  padding: 7px 13px;
  padding-left: 50px;
  font-size: 14px;
}
.btn.btn-LinkedIn svg {
  position: absolute;
  left: 7px;
  top: 4px;
  width: 26px;
  height: 26px;
}
.btn.btn-LinkedIn:after {
  position: absolute;
  left: 40px;
  top: 0;
  bottom: 0;
  content: "";
  width: 1px;
  background: #082a40;
}
.loader-profile {
  position: fixed;
  right: 0px;
  top: 0px;
  left: 0;
  bottom: 0;
  z-index: 30001;
  opacity: 1;
  transform: scale(2);
  justify-content: center;
  align-items: center;
  transition: all 0.5s ease;
  display: none;
}
.loader-profile.show {
  display: flex;
}
[contentEditable="true"]:empty:not(:focus):before {
  content: attr(data-text);
}
.socialLinkProf {
  margin: 10px 0 0 0;
}
.socialLinkProf a {
  width: 40px;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.socialLinkProf a svg {
  fill: #000000;
}
p.prof-website {
  display: block;
  text-align: center;
  margin-top: 12px;
  margin-top: 0 !important;
}
p.prof-website img {
  width: 33px;
  display: inline-block;
  vertical-align: middle;
}
p.prof-website a {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 50px);
  vertical-align: middle;
  padding-left: 8px;
  font-size: 17px;
  color: #000;
}
.socialLinkProf a span {
  display: none;
}
.socialLinkProf ul {
  display: flex;
  margin: 0 !important;
  padding: 0 !important;
  justify-content: center;
  align-items: center;
}
.profile-hld-box.showEdit .socialLinkProf ul {
  display: block;
}
.socialLinkProf ul li {
  display: inline-block;
  margin: 5px 5px 0;
}
.socialLinkProf ul li:focus {
  border-color: transparent;
}
.socialLinkProf ul li span {
  display: none;
}
#attendeeProfile.attendee-details-popup {
  height: auto;
  width: auto;
  max-width: none;
  max-height: none;
}
.attendee-first-last-name {
  display: none;
}
.profile-edit-box {
  display: none;
  width: 100%;
  border: none;
  height: 42px;
  padding: 0 0;
  border-bottom: 1px solid #ddd;
}
.prof-website .profile-edit-box {
  border: none;
  padding: 0 8px;
}
.socialLinkProf .profile-edit-box {
  border: none;
  padding: 0 8px;
}
.showEdit#profileSocial .profile-edit-box {
  display: block;
}
.showEdit#profileSocial .attendee-first-last-name {
  display: block;
  text-align: left;
  margin: 18px 0 0;
}
.showEdit#profileSocial .attendee-first-last-name h3 {
  display: inline;
  margin: 0;
  border: none;
}
.showEdit#profileSocial .attendee-first-last-name h3 + h3 {
  padding-left: 7px !important;
}
.showEdit#profileSocial .full-name {
  display: none;
}
.showEdit#profileSocial p#AttProfile[contenteditable="true"],
.showEdit#profileSocial.sponsors-box-hld h4[contenteditable="true"],
.showEdit#profileSocial p#Attcompany[contenteditable="true"],
.my-profile
  .showEdit#profileSocial.sponsors-box-hld
  h3[contenteditable="true"][contenteditable="true"] {
  padding: 10px 0;
  text-align: left;
}
.showEdit .title-line {
  display: block;
}
.showEdit#profileSocial .comma {
  display: none;
}
.showEdit#profileSocial .title-line p {
  padding-left: 0 !important;
}
.showEdit#profileSocial .socialLinkProf {
  margin: 0;
}
.showEdit#profileSocial .socialLinkProf ul li {
  display: flex;
  margin: 0;
  border-bottom: 1px solid #ddd;
  padding: 0 0;
}
.showEdit#profileSocial .socialLinkProf a {
  display: inline-flex;
  width: 30px;
  height: 30px;
}
.showEdit#profileSocial .socialLinkProf ul li span {
  display: inline-flex;
  width: calc(100% - 44px);
  height: 30px;
  padding: 4px 10px;
  overflow: hidden;
}
.showEdit#profileSocial .socialLinkProf ul li span * {
  white-space: nowrap;
  padding: 0;
  text-align: left;
}
.showEdit#profileSocial p.prof-website {
  display: flex;
  align-items: center;
  margin: 0 !important;
  border-bottom: 1px solid #ddd;
}
.showEdit#profileSocial p.prof-website svg {
  width: 30px;
  height: 27px;
  margin: 0 1px 0 3px;
}
.my-profile .showEdit#profileSocial.sponsors-box-hld h3 {
  margin-left: 0;
  margin-right: 0;
}
.showEdit#profileSocial p.prof-website a {
  width: calc(100% - 44px);
  text-align: left;
  color: #5d5c5c;
  font-size: 14px;
  padding-left: 19px;
}
.showEdit#profileSocial p.prof-website a,
.showEdit#profileSocial .socialLinkProf ul li span:focus {
  border-color: transparent;
  outline: none;
}
.showEdit#profileSocial #Attcompany,
.showEdit#profileSocial #AttName_first,
.showEdit#profileSocial #AttName_last,
.showEdit#profileSocial #Attcompany,
.showEdit#profileSocial #Attfacebook,
.showEdit#profileSocial #Atttwitter,
.showEdit#profileSocial #Attlinkedin,
.showEdit#profileSocial #Atttitle,
.showEdit#profileSocial #Attwebsite {
  display: none;
}
.showEdit#profileSocial .title-line p {
  text-align: left !important;
}
.showEdit .title-line {
  margin-bottom: 20px;
}
.profile-booth-image {
  width: 200px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #cbcbcb;
  overflow: hidden;
  border-radius: 5px;
  margin-right: 15px;
}
h4.profile-boothname {
  font-size: 20px;
  color: #000;
  margin-bottom: 5px !important;
  font-weight: 400;
}
p.profile-booth-desc {
  margin-bottom: 0 !important;
  color: #000;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
}
.profile-booth-list .v-list-item {
  border: 1px solid #cbcbcb;
  padding: 15px;
  border-radius: 5px;
  margin: 5px 0;
}
.profile-booth-list .v-list {
  padding: 0 !important;
}
.profile-booth-list {
  height: 476px;
  overflow-y: auto;
}
.profile-switch-wrap {
  box-shadow: rgb(0 0 0 / 10%) 0px 0.0625rem 0.125rem,
    rgb(0 0 0 / 15%) 0px 0.25rem 1rem -0.125rem;
  padding: 15px;
  border-radius: 10px;
  height: 100%;
}
.title-line p#AttEmail {
  font-size: 12px !important;
  word-break: break-word;
}
.profile-hld-box {
  border-radius: 10px !important;
  background: #fff;
}
.update-prof-button {
  background: #1976d2;
  padding: 8px 0;
  border-radius: 4px;
}
.profile-switch-wrap .v-tab {
  font-size: 15px;
  color: #000 !important;
}
.profile-switch-wrap .v-tabs-slider-wrapper {
  height: 3px !important;
  color: #000;
}
.keywords-add-button {
  width: 120px;
  height: 47px;
  background: #2876e5 !important;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 5px;
  margin-top: 3px;
}
button.submit-button {
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  .attendee-list .sponsors-box-hld .grey-bg-texthld {
    width: auto;
  }
  p#Attcompany {
    text-align: center;
  }
  .sponsors-box-hld p.edit-btn-set {
    margin-top: 20px;
  }
  .attendee-list .sponsors-box-hld span.attendee-img-area {
    overflow: visible;
    max-height: 140px;
    max-width: 140px;
  }
  .profile-wrapper-des-right {
    border-radius: 5px;
    padding: 0 10px;
  }
  .my-profile .attendee-list .sponsors-box-hld {
    border-radius: 5px;
  }
  .profile-wrapper-des-right,
  .my-profile .top-img-box {
    padding: 10px 14px !important;
  }
}
@media only screen and (max-width: 580px) {
  .d-flex.bni-cat {
    flex-direction: column;
  }
}
@media only screen and (max-width: 480px) {
  .d-flex.bni-cat {
    flex-direction: column;
  }
  .btn.btn-LinkedIn {
    width: 200px;
    position: relative;
    top: 0;
    right: 0;
    margin: auto;
  }
  .profile-wrapper-des-right p#AttProfile {
    padding-left: 0;
  }
  .edit-panel-cvr {
    margin-top: 10px;
  }
  .my-profile .sponsors-box-hld h3 {
    font-size: 20px;
  }
  .profile-wrapper-des-right h5 {
    text-align: center;
  }
}
</style>
<style scoped>
.v-application a {
  color: white;
}
</style>
